'use strict';

var addthis_share = {};

angular.module('huni', ['ngAnimate', 'ngCookies', 'ngRoute', 'ui.bootstrap', 'ng.shims.placeholder', 'angulartics', 'angulartics.google.analytics', 'summernote']);

angular.module('huni').config(['$routeProvider', function ($routeProvider) {
    var publicRoutes = {
        '/': {
            redirectTo: '/search'
        },
        '/search': {
            templateUrl: 'partials/search.html',
            controller: 'SearchController',
            title: 'Humanities Networked Infrastructure'
        },
        '/collections': {
            templateUrl: 'partials/collections.html',
            controller: 'CollectionListController',
            title: 'Collections'
        },
        '/collection/:id': {
            templateUrl: 'partials/collection.html',
            controller: 'CollectionController',
            title: 'Collection'
        },
        '/link/:id': {
            templateUrl: 'partials/link.html',
            controller: 'LinkController',
            title: 'Link'
        },
        '/results': {
            templateUrl: 'partials/results.html',
            controller: 'ResultsController',
            reloadOnSearch: false,
            title: 'Search Results'
        },
        '/record/:docid': {
            templateUrl: 'partials/network.html',
            controller: 'NetworkController',
            title: 'Record View'
        },
        '/record/:docid/:to_docid': {
            templateUrl: 'partials/network.html',
            controller: 'NetworkController',
            title: 'Record View'
        },
        '/contact': {
            templateUrl: 'partials/contact.html',
            controller: 'NewsletterListController',
            title: 'Contact'
        },
        '/login': {
            templateUrl: 'partials/login.html',
            controller: 'LoginController',
            title: 'Login'
        },
        '/user/:id': {
            templateUrl: 'partials/user.html',
            controller: 'UserController',
            title: 'User'
        },
        '/404': {
            templateUrl: 'partials/404.html',
            title: 'Page not found'
        }
    };

    var staticRoutes = ['about', 'data-policy', 'glossary', 'help', 'partners', 'technologies', 'bibliography', 'history', 'governance', 'terms-conditions'];
    _.each(staticRoutes, function (s) {
        var path = '/' + s;
        var title = s.substr(0, 1).toUpperCase() + s.substr(1); // ucfirst
        var templateUrl = 'partials/' + s + '.html';
        publicRoutes[path] = {
            templateUrl: templateUrl,
            title: title
        };
    });

    var privateRoutes = {
        '/myhuni/collections': {
            templateUrl: 'partials/myhuni/collections.html',
            controller: 'MyHuniCollectionsListController',
            title: 'My Collections'
        },
        '/myhuni/collection/:id': {
            templateUrl: 'partials/collection.html',
            controller: 'CollectionController',
            title: 'My Collection'
        },
        '/myhuni/collection/:id/manage': {
            templateUrl: 'partials/collection.html',
            controller: 'CollectionController',
            title: 'My Collection'
        },
        '/myhuni/collection/:id/users': {
            templateUrl: 'partials/myhuni/collection-users.html',
            controller: 'CollectionUsersController',
            title: 'My Collection Users'
        },
        '/myhuni/links': {
            templateUrl: 'partials/myhuni/links.html',
            controller: 'MyHuniLinkController',
            title: 'My Links'
        },
        '/myhuni/profile': {
            templateUrl: 'partials/myhuni/profile.html',
            controller: 'MyHuniProfileController',
            title: 'My Profile'
        },
        '/cms': {
            templateUrl: 'partials/cms.html',
            controller: 'CMSController',
            title: 'CMS',
            needsCanEdit: true
        }
    };

    function setRoutes(routes, needsLogin) {
        _.each(routes, function (properties, path) {
            properties.needsLogin = needsLogin;
            if (!properties.resolve) {
                properties.resolve = {};
            }
            properties.resolve.user = ['UserMgtService', function (user) {
                return user.loginStatus();
            }];
            $routeProvider.when(path, properties);
        });
    }

    setRoutes(publicRoutes, false);
    setRoutes(privateRoutes, true);

    $routeProvider.otherwise({ redirectTo: '/404' });
}]);

angular.module('huni').run(['$rootScope', '$route', '$location', '$anchorScroll', '$analytics', function ($rootScope, $route, $location, $anchorScroll, $analytics) {

    $rootScope.$on("$routeChangeSuccess", function (e, currRoute, prevRoute) {

        if (currRoute.locals.user && currRoute.locals.user.newUser) {
            // Redirect new users to the profile page
            $location.path('/myhuni/profile');
        } else if ($route.current.needsLogin) {
            // Send the user to the login page if necessary
            var user = currRoute.locals.user;
            var loggedIn = user && user.loggedIn;
            var canEdit = user && user.canEdit;
            if (!loggedIn) {
                var redir = $location.absUrl();
                $location.path('/login').search({ r: redir });
            } else if ($route.current.needsCanEdit && !canEdit) {
                $location.path('/404');
            }
        }

        // Change page title, based on route information
        $rootScope.title = $route.current.title;
        $anchorScroll(); // back to the top!

        // Replace the '#' in the url with share.
        //   eg. https://huni.net.au/share/search?c=Concept
        // This allows things like facebook to scrape pages properly.
        var addthis_url = $location.absUrl().replace('#', 'share');
        var addthis_description = 'Shared under HuNI’s Data Policy. See https://huni.net.au/#/data-policy';

        addthis_share = {
            url: addthis_url,
            url_transforms: {
                // The right way to share the query params
                add: $location.search()
            },
            title: $route.current.title,
            description: addthis_description,
            media: 'https://huni.net.au/images/huni-shared.png',
            passthrough: {
                twitter: {
                    text: $route.current.title + "\n" + addthis_description
                }
            }
        };

        $rootScope.addthis = addthis_share;
    });

    // Set the path without triggering a new route
    // http://stackoverflow.com/questions/14974271/can-you-change-a-path-without-reloading-the-controller-in-angularjs
    $location.sneakyPath = function (newPath) {
        var lastRoute = $route.current;
        var un = $rootScope.$on('$locationChangeSuccess', function () {
            $route.current = lastRoute;
            un();
        });
        var ret = $location.path(newPath);
        $analytics.pageTrack(newPath);
        return ret;
    };
}]);
'use strict';

angular.module('huni').controller('ChooseCollectionDialogController', ['$scope', '$modalInstance', 'HuniBackend', function ($scope, $modalInstance, huniBackend) {

    $scope.init = function () {
        $scope.loading = true;
        $scope.error = '';

        huniBackend.get('collection').success(function (collections) {
            $scope.collections = collections;
            $scope.tab = {
                choose_existing: {
                    active: collections.length > 0,
                    disabled: collections.length === 0
                },
                create_new: {
                    active: collections.length === 0,
                    disabled: false
                }
            };
            $scope.data = {
                newCollection: "",
                selectedCollection: _.size(collections) > 0 ? collections[0] : undefined
            };
        }).error(function () {
            $scope.error = 'There was an error loading your collections';
        }).finally(function () {
            $scope.loading = false;
        });
    };

    // The user hit the choose-existing button
    var select_existing = function select_existing() {
        //console.log("Selected ", $scope.selectedCollection);
        $modalInstance.close($scope.data.selectedCollection);
    };

    // The user hit the create-new button
    var create_new = function create_new() {
        var name = $scope.data.newCollection.trim();
        huniBackend.post('collection', { name: name }).success(function (response) {
            $modalInstance.close(response);
        }).error(function () {
            $scope.error = 'There as an error saving your collection';
        });
    };

    $scope.ok = function () {
        if ($scope.tab.choose_existing.active) {
            select_existing();
        } else if ($scope.tab.create_new.active) {
            create_new();
        } else {
            //console.log("Neither tab is active?");
            $modalInstance.dismiss("Internal error");
        }
    };

    $scope.init();
}]);
'use strict';

angular.module('huni').controller('CMSController', ['$scope', '$timeout', 'HuniBackend', function ($scope, $timeout, huniBackend) {

    $scope.documents = [];
    $scope.content = "";
    $scope.original = "";
    $scope.modified = false;
    $scope.history = [];
    $scope.selectedDoc = undefined;
    $scope.alertMessage = undefined;
    $scope.options = {
        toolbar: [['style', ['style']], ['font', ['bold', 'italic', 'underline', 'clear']], ['fontsize', ['fontsize']], ['color', ['color']], ['para', ['ul', 'ol', 'paragraph']], ['height', ['height']], ['table', ['table']], ['insert', ['link', 'picture', 'video', 'hr']], ['view', ['fullscreen', 'codeview']], ['help', ['help']]]
    };

    var alertTimeoutMillis = 2500;
    var alertId = 0;

    function showAlert(type, message) {
        $scope.alertType = type;
        $scope.alertMessage = message;

        // Each alert gets it's own version of alertId. In the case of two
        // overlapping alerts, this stops the early one from clearing the later
        // one.
        var myAlertId = ++alertId;
        $timeout(function () {
            if (alertId === myAlertId) {
                $scope.alertMessage = undefined;
            }
        }, alertTimeoutMillis);
    }

    function loadHistory() {
        var id = $scope.selectedDoc;
        huniBackend.get('cms/history/' + id).success(function (history) {
            $scope.history = history;
        });
    };

    $scope.load = function () {
        var id = $scope.selectedDoc;
        huniBackend.get('cms/' + id).success(function (content) {
            $scope.original = content;
            $scope.content = content;
            $scope.modified = false;
        });
        loadHistory();
    };

    $scope.save = function () {
        huniBackend.put('cms/' + $scope.selectedDoc, { content: $scope.content }).success(function (result) {
            $scope.original = $scope.content;
            $scope.modified = false;
            loadHistory();
            showAlert('success', "Saved " + $scope.selectedDoc + ".");
        }).error(function () {
            showAlert('danger', "There was an error saving " + $scope.selectedDoc + ".");
        });
    };

    $scope.revert = function () {
        $scope.content = $scope.original;
        showAlert('info', "Reset " + $scope.selectedDoc + " to version " + $scope.history[0].version + ".");
    };

    $scope.revertTo = function (version) {
        var id = $scope.selectedDoc;
        huniBackend.get('cms/' + id + '/' + version).success(function (content) {
            $scope.content = content;
            showAlert('info', "Reset " + id + " to version " + version + ".");
        });
    };

    $scope.closeAlert = function () {
        $scope.alertMessage = undefined;
    };

    $scope.$watch('content', function (newValue, oldValue) {
        $scope.modified = $scope.original !== $scope.content;
    });

    $scope.$watch('selectedDoc', function (newValue, oldValue) {
        if (!_.isUndefined(newValue)) {
            $scope.load();
        }
    });

    window.onbeforeunload = function () {
        if (!$scope.modified) {
            return;
        }
        return 'Your changes have not been saved';
    };

    $scope.$on('$locationChangeStart', function (event, next, current) {
        if ($scope.modified) {
            var answer = confirm('Your changes have not been saved.\n\n' + 'Are you sure you want to leave this page?');
            if (!answer) {
                event.preventDefault();
            }
        }
    });

    huniBackend.get('cms').success(function (data) {
        $scope.documents = data;
        $scope.selectedDoc = data[0];
    }).error(function () {
        console.log(arguments);
        showAlert('danger', 'Failed to load CMS document list. Try again later?');
    });
}]);
'use strict';

angular.module('huni').controller('PersistentCollapseController', ['$scope', 'SettingsService', function ($scope, settings) {

    $scope.group = 'collapse';

    $scope.init = function (key, defaultState) {
        $scope.key = key;
        $scope.defaultState = defaultState;
        $scope.isCollapsed = settings.get($scope.group, $scope.key);
        if (_.isUndefined($scope.isCollapsed)) {
            $scope.isCollapsed = defaultState;
        }
    };

    function setState(isCollapsed) {
        if ($scope.isCollapsed !== isCollapsed) {
            $scope.isCollapsed = isCollapsed;
            if ($scope.isCollapsed === $scope.defaultState) {
                settings.remove($scope.group, $scope.key);
            } else {
                settings.set($scope.group, $scope.key, isCollapsed);
            }
        }
    }

    $scope.toggleCollapsed = function () {
        setState(!$scope.isCollapsed);
    };

    $scope.collapse = function () {
        setState(true);
    };

    $scope.expand = function () {
        setState(false);
    };
}]);
'use strict';

angular.module('huni').controller('CollectionController', ['$rootScope', '$scope', '$location', '$routeParams', 'HuniBackend', 'SolrSearchService', function CollectionController($rootScope, $scope, $location, $routeParams, huniBackend, solr) {

    function pathHas(str) {
        return $location.path().indexOf(str) >= 0;
    }

    function getCollection(id) {
        var endPoint = $scope.isPublic ? 'publication' : 'collection';
        $scope.status = 'loading';
        huniBackend.get(endPoint + '/' + id).success(function (result) {
            $rootScope.title = result.name + ' - ' + ($scope.isPublic ? '' : 'My ') + 'Collection';
            solr.augmentRecords(result.records).then(function (merged) {
                result.records = merged;
                $scope.collection = result;
                if (pathHas('/manage')) {
                    $scope.$emit('EditCollectionEvent', result);
                }
                if ($scope.isPublic) {
                    updateAddThisDetails();
                }
                $scope.status = 'ok';
            });
        }).error(function (error) {
            $scope.status = error.status === '404' ? 'empty' : 'error';
        });
    }

    function join(list) {
        list = angular.copy(list);
        list.sort();

        if (list.length == 1) {
            return list[0];
        }

        var last = list.pop();
        return list.join(", ") + " and " + last;
    }

    function updateAddThisDetails() {
        var c = $scope.collection;

        addthis_share.title = "HuNI Public Collection: " + c.name;

        var users = _.pluck(c.owners, 'name');
        addthis_share.description = "Created by " + join(users) + ".\n" + 'Shared under HuNI’s Data Policy. See https://huni.net.au/#/data-policy';

        addthis_share.passthrough.twitter.text = addthis_share.title + "\n" + addthis_share.description;
    }

    function init() {
        $scope.isPublic = !pathHas('myhuni');
        //$scope.collection = undefined;
        getCollection($routeParams.id);
    }

    init();
}]);
'use strict';

angular.module('huni').controller('CollectionDetailsDialogController', ['$scope', '$modalInstance', 'collection', 'permissions', function ($scope, $modalInstance, collection, permissions) {
    $scope.name = collection.name;
    $scope.synopsis = collection.synopsis;
    $scope.permissions = permissions;
    $scope.title = permissions.can_edit_title ? "Collection Details" : "Collection Notes";

    $scope.close = function () {
        // What fields we can save depends on our user level. We already check
        // permissions to determine what we can edit. Rather than check the
        // permissions again here, just return what has changed. If we can
        // change it, we should be able to save it.
        var fields = ['name', 'synopsis'];
        var updatedFields = _.filter(fields, function (f) {
            return $scope[f] != collection[f];
        });
        var updates = _.pick($scope, updatedFields);

        return $scope.$close(updates);
    };
}]);
'use strict';

angular.module('huni').controller('CollectionListController', ['$scope', '$routeParams', '$location', 'HuniBackend', 'SolrSearchService', function ($scope, $routeParams, $location, huniBackend, solrSearchService) {

    function init() {
        var params = $location.search();
        $scope.data = {
            page: params.p || 1,
            rows: params.n || 10,
            searchTerm: params.q || ''
        };
        // We need this to fake the pagination controller out.
        $scope.data.total = $scope.data.page * $scope.data.rows;
        $scope.collections = [];

        $scope.loadCollections();
    }

    function makeParams() {
        var params = {
            p: $scope.data.page,
            n: $scope.data.rows
        };
        var search = $scope.data.searchTerm.trim();
        if (search.length > 0) {
            params.q = search;
        }
        return params;
    }

    $scope.reload = function () {
        var params = makeParams();
        var oldParams = $location.search();
        if (!_.isEqual(params, oldParams)) {
            $location.search(params);
        }
    };

    $scope.updatePage = $scope.reload;
    $scope.updateSearchTerm = $scope.reload;

    $scope.loadCollections = function () {
        $scope.status = 'loading';
        huniBackend.get('publication', makeParams()).success(function (data) {
            $scope.status = data.total === 0 ? 'empty' : 'ok';
            $scope.data.total = data.total;
            $scope.collections = data.publications;
        }).error(function () {
            $scope.status = 'error';
        });
    };

    init();
}]);
'use strict';

angular.module('huni').controller('CollectionUsersController', ['$scope', '$rootScope', '$routeParams', '$location', 'CollectionRole', 'HuniBackend', 'UserMgtService', function ($scope, $rootScope, $routeParams, $location, collectionRole, huni, userMgt) {

    var collectionId = $routeParams.id;

    function showSuccess(message) {
        $scope.userAlert = {
            type: 'success',
            message: message
        };
    }

    function showError(message) {
        $scope.userAlert = {
            type: 'danger',
            message: message
        };
    }

    function getUser() {
        return userMgt.loginStatus().then(function (user) {
            $scope.user = user;
        }, function (error) {
            $scope.status = 'error';
        });
    }

    function getCollectionUsers() {
        return huni.get('collection/' + collectionId + '/user').success(function (result) {
            $rootScope.title = result.name + ' - ' + 'My Collection';
            // Filter the active user from the list.
            $scope.users = _.reject(result, function (user) {
                return user.user_id == $scope.user.id;
            });

            $scope.status = 'ok';
        }).error(function (error) {
            if (error.status == 404) {
                $location.path("/404");
            } else {
                $scope.status = 'error';
            }
        });
    }

    function canModify(user) {
        if (user.role_id != 'owner') {
            // You can modify non-owners.
            return true;
        }

        if (user.inviting_user_id == $scope.user.id) {
            // You can also modify owners, but only if they were added by you.
            return true;
        }

        return false;
    }

    function getCollectionInfo() {
        return huni.get('collection/' + collectionId).success(function (result) {
            $scope.collection = result;
            $rootScope.title = result.name + ' - Collection Users';
        }).error(function (error) {});
    }

    function roleDescr(role_id) {
        return collectionRole.getInfo(role_id).description;
    }

    function updateRole(user) {
        var path = '/collection/' + collectionId + '/user/' + user.user_id + '/' + user.role_id;

        huni.put(path).success(function (result) {
            showSuccess(user.user.name + ' is now ' + roleDescr(user.role_id));
        }).error(function (error) {
            showError("Updating user failed. Try again?");
        });
    }

    function addUser() {
        var name = $scope.newUser.user.name;
        var user_id = $scope.newUser.user.id;
        var role_id = $scope.newUser.role_id;

        var path = '/collection/' + collectionId + '/user/' + user_id + '/' + role_id;

        huni.put(path).success(function (result) {
            showSuccess('Added ' + name + ' as ' + roleDescr(role_id));
            $scope.newUser.user = null;
            $scope.users.push(result);
        }).error(function (error) {
            showError('Adding ' + name + ' failed. Try again?');
        });
    }

    function removeUser(user) {
        var path = '/collection/' + collectionId + '/user/' + user.user_id;

        huni.delete(path).success(function (result) {
            $scope.users = _.reject($scope.users, function (u) {
                return u.user_id === user.user_id;
            });
            showSuccess(user.user.name + ' removed from collection');
        }).error(function (error) {
            showError("Error removing user. Try again?");
        });
    }

    function userTypeahead(prefix) {
        var path = '/collection/' + collectionId + '/user/suggest?q=' + window.encodeURIComponent(prefix);

        return huni.get(path).then(function (response) {
            return response.data;
        });
    }

    var roleOptions = collectionRole.options();
    var newUser = { role_id: "read-only" };

    function init() {
        $scope.status = 'loading';
        getUser().then(getCollectionUsers);
        getCollectionInfo();

        _.extend($scope, {
            addUser: addUser,
            canModify: canModify,
            newUser: newUser,
            removeUser: removeUser,
            roleOptions: roleOptions,
            updateRole: updateRole,
            userTypeahead: userTypeahead
        });
    }

    init();
}]);
'use strict';

angular.module('huni').controller('CreateLinktypeDialogController', ['$scope', '$modalInstance', 'HuniBackend', 'fromRecord', 'toRecord', 'suggestions', 'lhsName', function CreateLinktypeDialogController($scope, $modalInstance, huniBackend, fromRecord, toRecord, suggestions, lhsName) {

    function getSuggestions(key) {
        return _.chain(suggestions).pluck(key).sort().uniq(true).value();
    }

    function init() {
        $scope.fromRecord = fromRecord;
        $scope.toRecord = toRecord;
        $scope.names = getSuggestions('name');
        $scope.pairs = getSuggestions('pair');
        $scope.data = {
            name: lhsName,
            pair: '',
            symmetric: false
        };
    }

    $scope.ok = function () {
        var pair = $scope.data.symmetric ? $scope.data.name : $scope.data.pair;
        huniBackend.post('linktype', {
            name: $scope.data.name,
            pair: pair,
            from: $scope.fromRecord.entityType,
            to: $scope.toRecord.entityType
        }).success(function (result) {
            //TODO: post linktype should return this pair
            result.pair = pair;
            $modalInstance.close(result);
        });
    };

    init();
}]);
'use strict';

angular.module('huni').controller('LinkController', ['$rootScope', '$scope', '$routeParams', 'HuniBackend', 'SolrSearchService', 'DialogService', function ($rootScope, $scope, $routeParams, huni, solr, dialog) {

    function augmentLink(link) {

        return solr.getRecords([link.from_docid, link.to_docid]).then(function (records) {
            var record = _.indexBy(records, 'docid');
            link.from = record[link.from_docid];
            link.to = record[link.to_docid];

            $rootScope.title = link.from.displayName + " → " + link.to.displayName + " - Link";
            $scope.link = link;
            $scope.status = 'ok';
        }, function () {
            $scope.status = 'error';
        });
    }

    function fetchLink(id) {
        $scope.status = 'loading';
        huni.get('link' + '/' + id).success(augmentLink).error(function () {
            $scope.status = 'empty';
        });
    }

    $rootScope.$on('LinkChangedEvent', function (event, data) {
        _.extend($scope.link, data.link);
    });

    $scope.editLink = function (link) {
        $scope.$emit('EditLinkEvent', link);
    };

    function init() {
        $scope.link = undefined;
        fetchLink($routeParams.id);
    }

    init();
}]);
'use strict';

angular.module('huni').controller('LoginController', ['$rootScope', '$scope', '$location', 'HuniBackend', function ($rootScope, $scope, $location, huni) {

    var opts = {
        lines: 15, // The number of lines to draw
        length: 16, // The length of each line
        width: 3, // The line thickness
        radius: 12, // The radius of the inner circle
        corners: 1, // Corner roundness (0..1)
        rotate: 0, // The rotation offset
        direction: 1, // 1: clockwise, -1: counterclockwise
        color: '#000', // #rgb or #rrggbb
        speed: 1, // Rounds per second
        trail: 60, // Afterglow percentage
        shadow: false, // Whether to render a shadow
        hwaccel: false, // Whether to use hardware acceleration
        className: 'spinner', // The CSS class to assign to the spinner
        zIndex: 2e9, // The z-index (defaults to 2000000000)
        top: 'auto', // Top position relative to parent in px
        left: 'auto' // Left position relative to parent in px
    };

    // init - get list and total, available document count
    $scope.onLogin = function (provider) {
        $scope.providers_visible = false;
        var target = document.getElementById('spinner');
        var spinner = new Spinner(opts).spin(target);
        return spinner;
    };

    // The login page gets passed a return-destination redirect value
    // as ?r=$redirect. We pass that onto the login links.
    function makeUri(provider_id) {
        var params = $location.search();
        var uri = huni.uri('login/' + provider_id);
        if (params.r) {
            uri += '?r=' + encodeURIComponent(params.r);
        }
        return uri;
    }

    $scope.providers_visible = true;
    $scope.providers = [];

    // Load the list of active providers from the backend
    huni.get('login').success(function (providers) {
        _.each(providers, function (provider) {
            provider.uri = makeUri(provider.id);
        });
        $scope.providers = providers;
    });
}]);
'use strict';

angular.module('huni').controller('MyHuniCollectionsListController', ['$scope', 'HuniBackend', function ($scope, huniBackend) {

    function init() {
        $scope.userAlert = {};
        $scope.getCollectionList();
    }

    $scope.getCollectionList = function () {
        $scope.status = 'loading';
        huniBackend.get('collection').success(function (response) {
            $scope.collections = response;
            $scope.status = response.length === 0 ? 'empty' : 'ok';
        }).error(function () {
            $scope.status = 'error';
        });
    };

    init();
}]);
'use strict';

angular.module('huni').controller('MyHuniLinkController', ['$rootScope', '$scope', '$timeout', 'HuniBackend', 'SolrSearchService', 'DialogService', function ($rootScope, $scope, $timeout, huni, solr, dialog) {

    function setMessage(type, msg) {
        $scope.userAlert.type = type;
        $scope.userAlert.message = msg;
    }
    function ok(msg) {
        setMessage('success', msg);
    }
    function error(msg) {
        setMessage('danger', msg);
    }

    function augmentLinks(links) {
        var from_docids = _.pluck(links, 'from_docid');
        var to_docids = _.pluck(links, 'to_docid');
        var docids = _.uniq(from_docids.concat(to_docids));

        return solr.getRecords(docids).then(function (records) {
            var record = _.indexBy(records, 'docid');
            _.each(links, function (link) {
                link.from = record[link.from_docid];
                link.to = record[link.to_docid];
            });

            $scope.links = links;
            $scope.status = links.length === 0 ? 'empty' : 'ok';
        });
    }

    function fetchLinks() {
        $scope.status = 'loading';
        huni.get('link').success(augmentLinks).error(function () {
            $scope.status = 'error';
        });
    }

    $rootScope.$on('LinkChangedEvent', fetchLinks);

    $scope.editLink = function (link) {
        $scope.$emit('EditLinkEvent', link);
    };

    $scope.deleteLink = function (link) {
        var linkName = link.from.displayName + ' ' + link.linktype + ' ' + link.to.displayName;
        dialog.confirmationDialog('Really delete "' + linkName + '"?').then(function () {
            huni.delete('link/' + link.id).success(function () {
                var index = $scope.links.indexOf(link);
                $scope.links.splice(index, 1);
                ok('Deleted "' + linkName + '"');
            }).error(function () {
                error('There was an error deleting"' + linkName + '"');
            });
        });
    };

    function init() {
        $scope.links = undefined;
        $scope.userAlert = {};
        fetchLinks();
    }

    init();
}]);
'use strict';

angular.module('huni').controller('MyHuniProfileController', ['$rootScope', '$scope', 'HuniBackend', function ($rootScope, $scope, huni) {
    function setMessage(type, msg) {
        $scope.userAlert.type = type;
        $scope.userAlert.message = msg;
    }

    function ok(msg) {
        setMessage('success', msg);
    }
    function error(msg) {
        setMessage('danger', msg);
    }

    function getProfile() {
        $scope.status = 'loading';
        huni.get('profile').success(function (response) {
            $scope.user = response;
            $scope.status = 'ok';
        }).error(function () {
            $scope.status = 'error';
        });
    }

    $scope.update = function () {
        huni.put('profile', $scope.user).success(function () {
            ok('Your user profile was updated successfully.');
            $rootScope.$broadcast('ProfileChangedEvent', $scope.user);
        }).error(function () {
            error('There was a problem saving your user profile.');
        });
    };

    function init() {
        $scope.userAlert = {};
        if ($scope.user.newUser) {
            // If we've detected a new user, say hello, and then behold as they
            // immediately become oldbies.
            $scope.user.newUser = false;
            ok('Welcome to HuNI!');
        }
        getProfile();
    }

    init();
}]);
'use strict';

angular.module('huni').controller('NetworkController', ['$scope', '$location', '$routeParams', '$q', 'GraphQueryService', 'SolrSearchService', 'HuniBackend', 'DialogService', 'EmbeddedMode', function ($scope, $location, $routeParams, $q, graphQuery, solr, huni, dialog, EmbeddedMode) {

    /*
    
    TODO:
    
    1. Create a hash of all 'expanded' records and collections.
    2. Use this as a cache when fetching record info.
    
    This will allow us to:
    3. Pre-fetch leaf nodes as soon as they appear in the graph
    
    The idea is that each leaf node already has all its links
    pre-populated, and when the user activates that node, we can
    immediately populate it, and then do fetch on the new leaf nodes.
    
     */

    // Need this to shut jslint up
    /*global setFocusRecord: false */
    var collectionPrefix = 'HuNI***Collection***';

    $scope.activeEdges = [];

    function showLinkDialog(link) {
        return dialog.linkDialog(link);
    }

    // Make a collection object look like a record
    function recordiseCollection(c) {
        c.entityType = 'Collection';
        c.docid = collectionPrefix + c.id;
        c.displayName = c.name;
        var prefix = $scope.user.owns(c) ? '#/myhuni' : '#';
        c.link = prefix + '/collection/' + c.id;
        c.description = c.synopsis;
    }

    function nodeSize(d) {
        var scale = 1.8;
        var base = 30;
        return d.docid === $scope.record.docid ? base * scale : base;
    }

    function getGraphSize() {
        $scope.embedded = EmbeddedMode.get();

        var container = document.getElementById('main-container');
        var width = container.offsetWidth - 100;

        var height = 0;
        if ($scope.embedded) {
            /* aligns bottom of graph to top of text 
            NEED TO ACCOUNT FOR WRAPPED TEXT */
            height = window.innerHeight - 138;
        } else {
            height = window.innerHeight * 0.6;
        };

        return { width: width, height: height };
    }

    function translate(x, y) {
        return "translate(" + x + "," + y + ")";
    }

    function linkTransform(link) {
        return translate((link.source.x + link.target.x) * 0.5, (link.source.y + link.target.y) * 0.5);
    }

    function onGraphTick() {
        $scope.edge.attr("x1", function (d) {
            return d.source.x;
        }).attr("y1", function (d) {
            return d.source.y;
        }).attr("x2", function (d) {
            return d.target.x;
        }).attr("y2", function (d) {
            return d.target.y;
        });

        $scope.node.attr("xlink:href", function (d) {
            var file = d.entityType.toLowerCase();
            if (!d.loaded) {
                file += '-unloaded';
            }
            var href = 'images/graph/' + file + '.svg';
            return href;
        }).attr("height", nodeSize).attr("width", nodeSize).attr("transform", function (d) {
            var sz = nodeSize(d) / 2;
            return translate(d.x - sz, d.y - sz);
        });

        $scope.nodeLabels.attr("x", function (d) {
            return 5 + nodeSize(d) / 2;
        }).attr("transform", function (d) {
            return translate(d.x, d.y);
        });

        $scope.edgeLabels.attr("transform", linkTransform);
    }

    function resizeGraph() {
        // http://stackoverflow.com/questions/16265123/resize-svg-when-window-is-resized-in-d3-js
        var size = getGraphSize();

        // set attrs and 'resume' force
        $scope.svg.attr('width', size.width);
        $scope.svg.attr('height', size.height);
        $scope.graph.size([size.width, size.height]).resume();
    }

    function isOffScreen(x, y) {
        if (x < 0) {
            return true;
        }
        if (y < 0) {
            return true;
        }

        var size = $scope.graph.size();
        if (x >= size[0]) {
            return true;
        }
        if (y >= size[1]) {
            return true;
        }
        return false;
    }

    function initGraph() {
        var size = getGraphSize();

        var graph = d3.layout.force();
        graph.charge(-800).friction(0.75).linkDistance(100).linkStrength(1).nodes($scope.nodes).links($scope.edges).size([size.width, size.height]);
        graph.on("tick", onGraphTick);

        $scope.graph = graph;

        var svg = d3.select("#graph").append("svg");
        svg.attr("width", size.width).attr("height", size.height);

        $scope.svg = svg;

        // The "g" here is important. It groups the links and nodes together
        // into their own objects. This way all the nodes are drawn after all
        // the links. If we don't have these, a new link draws on top of
        // everything.
        $scope.edge = svg.append("g").selectAll();
        $scope.node = svg.append("g").selectAll();
        $scope.nodeLabels = svg.append("g").selectAll();
        $scope.edgeLabels = svg.append("g").selectAll();

        $scope.drag = graph.drag().on("dragend", function (d) {
            // Un-fix nodes that have been dragged off-screen
            if (d.fixed && isOffScreen(d.x, d.y)) {
                d.fixed = false;
            }
        });

        d3.select(window).on('resize', resizeGraph);
    }

    function makeLink(linkData) {
        var link = _.clone(linkData);

        function swap(object, key0, key1) {
            var t = object[key1];
            object[key1] = object[key0];
            object[key0] = t;
        }

        if (link.from_docid != $scope.record.docid) {
            swap(link, 'from_docid', 'to_docid');
            swap(link, 'linktype_id', 'pairtype_id');
            swap(link, 'linktype', 'pairtype');
        }

        delete link.record;
        link.from = $scope.nodeMap[link.from_docid];
        link.to = $scope.nodeMap[link.to_docid];

        return link;
    }

    function updateEdgeLabels() {
        /* disabled for now
        $scope.edgeLabels = $scope.edgeLabels.data($scope.activeEdges);
        $scope.edgeLabels.enter()
            .append("text")
              .attr('class', 'graph-text edge-label')
              .attr("x", function(d) { return 3 + nodeSize(d) / 2; })
              .attr("y", ".35em")
              .attr("transform", linkTransform)
              .text(function(d) {
                  let relationship = (d.link.from_docid == $scope.record.docid)
                        ? d.link.linktype : d.link.pairtype;
                  let words = [
                      d.source.displayName,
                      relationship.toLowerCase(),
                      d.target.displayName,
                  ];
                  if (d.source.docid != $scope.record.docid) {
                      words.reverse();
                  }
                   return words.join(' ');
              })
            ;
        $scope.edgeLabels.exit().remove();
        */
    }

    function drawGraph() {
        $scope.edge = $scope.edge.data($scope.graph.links());
        $scope.edge.enter().append("line", ".node").attr("class", function (d) {
            if (d.link.user_id === 1) {
                return "graph-link system";
            }
            if (d.source.entityType === 'Collection') {
                return "graph-link collection";
            }
            if (d.target.entityType === 'Collection') {
                return "graph-link collection";
            }
            return "graph-link";
        }).attr("id", function (d) {
            return "link-" + d.id;
        }).on('mouseover', function (d) {
            d.source.fixed = d.target.fixed = true;
            var edge = d3.select(this).classed("active", true);
            $scope.activeEdges = [d];
            updateEdgeLabels();
        }).on('mouseout', function (d) {
            var edge = d3.select(this).classed("active", false);
            d.source.fixed = d.target.fixed = false;
            if ($scope.activeEdges[0] == d) {
                $scope.activeEdges = [];
                updateEdgeLabels();
            }
        }).on('click', function (d) {
            var link = makeLink(d.link);
            showLinkDialog(link);
        });
        $scope.edge.exit().remove();
        $scope.node = $scope.node.data($scope.graph.nodes());

        $scope.node.enter().append("image", ".node").call($scope.drag).on("click", function (d) {
            if (d3.event.defaultPrevented) {
                return;
            } // ignore drag
            setFocusRecord(d);
        });
        $scope.node.exit().remove();

        $scope.nodeLabels = $scope.nodeLabels.data($scope.graph.nodes());
        $scope.nodeLabels.enter().append("text").attr("class", "graph-text node-label").attr("y", ".35em").text(function (d) {
            return d.displayName || d.key;
        });
        $scope.nodeLabels.exit().remove();

        $scope.edgeLabels = $scope.edgeLabels.data($scope.activeEdges);
        $scope.edgeLabels.enter().append("text").attr('class', 'graph-text edge-label').attr("y", ".35em").text(function (d) {
            return d.key;
        });
        $scope.edgeLabels.exit().remove();

        $scope.graph.start();
    }

    function recordPos() {
        var isFirstNode = $scope.nodes.length === 0;
        var size = $scope.graph.size();

        // Spread is betwen 0 and 1
        var spread = isFirstNode ? 0 : 0.2;

        function r() {
            return (Math.random() - 0.5) * spread + 0.5;
        }

        return {
            x: size[0] * r(), y: size[1] * r()
        };
    }

    function addNode(record) {
        var node = $scope.nodeMap[record.docid];
        if (node) {
            return node;
        }

        var pos = record.initialPos || recordPos();
        record.px = record.x = pos.x;
        record.py = record.y = pos.y;
        $scope.nodes.push(record);
        $scope.nodeMap[record.docid] = record;

        return record;
    }

    function edgeKey(link) {
        if (link.from_docid < link.to_docid) {
            return link.from_docid + '->' + link.to_docid;
        } else {
            return link.to_docid + '->' + link.from_docid;
        }
    }

    function makeEdge(source, target, link) {
        if (source.docid > target.docid) {
            var t = source;
            source = target;
            target = t;
        }
        var key = source.docid + '->' + target.docid;
        return { key: key, source: source, target: target, link: link };
    }

    function addEdge(source, target, link) {
        var edge = makeEdge(source, target, link);
        var oldEdge = $scope.edgeMap[edge.key];
        if (oldEdge) {
            return oldEdge;
        }

        $scope.edges.push(edge);
        $scope.edgeMap[edge.key] = edge;

        return edge;
    }

    function removeEdge(source, target) {
        var key = makeEdge(source, target).key;
        var edge = $scope.edgeMap[key];
        if (!edge) {
            return false;
        }

        var index = _.indexOf($scope.edges, edge);
        $scope.edges.splice(index, 1);
        delete $scope.edgeMap[key];
        return true;
    }

    function updateGraph(record) {
        if (!_.has(record, 'displayName')) {
            return;
        }
        if (!$scope.graph) {
            initGraph();
        }
        record.loaded = true;
        var source = addNode(record);
        _.each(record.links, function (link) {
            var target = addNode(link.record);
            addEdge(source, target, link);
        });
        _.each(_.values(record.collections), function (collection) {
            var target = addNode(collection);
            addEdge(source, target, makeCollectionLink(collection, source));
        });
        drawGraph();
    }

    function makeCollectionLink(collection, record) {
        return {
            linktype: 'contains',
            pairtype: 'contained in',
            user: {
                name: record.username,
                id: record.user_id
            },
            from_docid: collectionPrefix + collection.id,
            to_docid: record.docid,
            record: record
        };
    }

    // Get the records for a collection, and then get the solr
    // data for those records. Returns a promise.
    function getCollectionInfo(collection) {
        var p = huni.get('publication/' + collection.id);
        p = p.then(function (resp) {
            var c = resp.data;
            if (!_.has(collection, 'displayName')) {
                collection.name = c.name;
                collection.synopsis = c.synopsis;
                collection.is_public = c.is_public;
                collection.created_utc = c.created_utc;
                collection.modified_utc = c.modified_utc;
                recordiseCollection(collection);
            }
            var records = c.records;
            collection.links = _.map(records, function (r) {
                return makeCollectionLink(c, r);
            });
            return solr.augmentRecords(records);
        });
        return p.then(function () {
            updateGraph(collection);
        });
    }

    // Gets the links for a record, and populates those with
    // record fields. Returns a promise.
    function getLinksForRecord(record) {
        return huni.get('/record/' + record.docid + '/link').then(function (resp) {
            record.links = resp.data;
            record.linkCount = record.links.length;
            var linkedRecords = _.map(record.links, function (link) {
                link.record = { docid: link.to_docid };
                return link.record;
            });
            return solr.augmentRecords(linkedRecords);
        });
    }

    // Gets the collections for a record. Returns a promise.
    function getCollectionsForRecord(record) {
        return huni.get('/record/' + record.docid + '/collection').success(function (collections) {
            _.each(collections, recordiseCollection);
            record.collections = _.indexBy(collections, 'id');
        });
    }

    // For a record, gets the record info, the links and
    // the collections. Once those are all available, redraw the
    // graph.
    function getRecordInfo(record) {
        var promises = [];
        if (!_.has(record, 'displayName')) {
            promises.push(solr.augmentRecords([record]));
        }
        promises.push(getLinksForRecord(record));
        promises.push(getCollectionsForRecord(record));

        var all = $q.all(promises);
        return all.then(function () {
            updateGraph(record);
        });
    }

    function setFocusRecord(record) {
        // Alway fix the focused record, even if it was already focused.
        // It may have been dragged off-screen and un-fixed.
        record.fixed = true;
        if ($scope.record === record) {
            return;
        }
        $scope.record.fixed = false;
        $scope.record = record;

        var path = '/record/' + record.docid;
        $location.sneakyPath(path);
        //drawGraph();

        if (record.entityType === 'Collection') {
            getCollectionInfo(record).then(updateAddThisInfo);
        } else {
            getRecordInfo(record).then(updateAddThisInfo);
        }
    }

    function updateLink(source_docid, target_docid, link, doAdd) {
        var source = $scope.nodeMap[source_docid];
        if (!source) {
            return;
        }

        var target = $scope.nodeMap[target_docid];
        if (!target) {
            return;
        }

        if (doAdd) {
            addEdge(source, target, link);
        } else {
            removeEdge(source, target);
        }

        drawGraph();
    }

    $scope.$on('LinkChangedEvent', function (event, data) {
        // Update the graph links
        updateLink(data.link.from_docid, data.link.to_docid, data.link, data.action === 'created');

        // Update the links data if this is a new link and it involves the
        // selected record. This will update the link table properly.
        if (data.action === 'created' && (data.link.to_docid === $scope.record.docid || data.link.from_docid === $scope.record.docid)) {
            getLinksForRecord($scope.record).then(function () {
                updateGraph($scope.record);
            });
        }
    });

    $scope.$on('CollectionChangedEvent', function (event, data) {
        if (data.added && data.record.docid === $scope.record.docid) {
            // The selected record got added to this collection.
            recordiseCollection(data.collection);
            addNode(data.collection);
        }

        updateLink(collectionPrefix + data.collection.id, data.record.docid, makeCollectionLink(data.collection, data.record), data.added);
    });

    $scope.$on('RecordSelectedEvent', function (event, docid) {
        var record = $scope.nodeMap[docid];
        if (record) {
            setFocusRecord(record);
        }
    });

    $scope.$on('ViewLinkEvent', function (event, link) {
        var key = edgeKey(link);
        $scope.edge.classed('active', function (d) {
            return d.key == key;
        });
        //console.log('ViewLinkEvent', link);
        //showLinkDialog(makeLink(link));
    });

    $scope.$on('HighlightLinkEvent', function (event, link, isHighlighted) {
        if (link.entityType === 'Collection') {
            link = makeCollectionLink(link, $scope.record);
        }
        var key = edgeKey(link);
        $scope.edge.classed('active', function (d) {
            var activated = isHighlighted && d.key === key;
            return activated;
        });
    });

    function initSingleRecord(docid) {
        $scope.record = { docid: docid, fixed: true };
        $scope.nodes = [];
        $scope.edges = [];
        $scope.nodeMap = {};
        $scope.edgeMap = [];
        $scope.status = 'loading';
        //TODO: use collectionPrefix
        var p;
        if (docid.match(/^HuNI\*\*\*Collection\*\*\*(\d+)$/)) {
            var match = docid.match(/\d+/);
            $scope.record.id = match[0];
            p = getCollectionInfo($scope.record);
        } else {
            p = getRecordInfo($scope.record);
        }
        p.finally(function () {
            // solr.augmentRecords doesn't propogate errors for missing
            // records, so just check that we got something here.
            $scope.status = _.has($scope.record, 'displayName') ? 'ok' : 'empty';

            updateAddThisInfo();
        });
    }

    function setChain(recordsAndLinks) {
        if (!$scope.graph) {
            initGraph();
        }

        // We either have a path [ node, link, node, link, node ], or a
        // disjoint pair [ node, node ].
        // We don't actually use the link objects here, so filter them out.
        var hasLinks = recordsAndLinks.length > 2;
        var records = hasLinks ? _.filter(recordsAndLinks, function (x) {
            return _.has(x, 'docid');
        }) : recordsAndLinks;
        var links = _.filter(recordsAndLinks, function (x) {
            return !_.has(x, 'docid');
        });

        var size = $scope.graph.size();
        var n = records.length + 1;
        var w = size[0];
        var y = size[1] / 2;

        // Add a little vertical zig-zag to the y positions so that the nodes
        // don't all appear in a straight horizontal line. This value gets
        // negated for each node.
        var yBump = 15;

        // Augment each record with the displayName property.
        // Add the nodes to the graph, and if necessary, the links as well.
        var prev = undefined;
        _.each(records, function (record, index) {
            record.initialPos = { x: (index + 1) * w / n, y: y + yBump };
            yBump = -yBump;

            var source = addNode(record);
            if (hasLinks && prev) {
                var link = links[index - 1]; // link to previous node
                addEdge(prev, source, link);
            }
            prev = source;
        });

        // Populate the links for the first and last nodes.
        getRecordInfo($scope.record);
        getRecordInfo(prev);

        $scope.status = 'ok';
    }

    function updateAddThisInfo() {
        addthis_share.title = "HuNI Record View: " + $scope.record.displayName;
        addthis_share.passthrough.twitter.text = addthis_share.title + "\n" + addthis_share.description;
    }

    function initShortestPath(from_docid, to_docid) {
        $scope.record = { docid: from_docid, fixed: true };
        $scope.nodes = [];
        $scope.edges = [];
        $scope.nodeMap = {};
        $scope.edgeMap = [];
        $scope.status = 'loading';

        graphQuery.shortestPathQuery(from_docid, to_docid).then(function (result) {
            if (result.length == 0) {
                $scope.status = 'empty';
                return;
            }
            $scope.record = result[0];
            setChain(result);
        });
    }

    if ($routeParams.to_docid) {
        initShortestPath($routeParams.docid, $routeParams.to_docid);
    } else {
        initSingleRecord($routeParams.docid);
    }
}]);
'use strict';

angular.module('huni').controller('NewsletterListController', ['$scope', '$http', 'cfg', '$routeParams', '$location', 'HuniBackend', function ($scope, $http, cfg, $routeParams, $location, huniBackend) {

    function init() {
        $scope.loadNewsletters();
    }

    $scope.loadNewsletters = function () {
        $scope.status = 'loading';
        var newsletters_base = cfg.newsletters || '';
        $http.get(newsletters_base + '/api-createsend-com/huni-newsletters').success(function (data) {
            $scope.status = data.length === 0 ? 'empty' : 'ok';
            $scope.newsletters = data;
        }).error(function () {
            $scope.status = 'error';
        });
    };

    init();
}]);
'use strict';

angular.module('huni').controller('ResultsController', ['$scope', '$routeParams', '$location', '$anchorScroll', '$analytics', 'ReachableNodesSearch', 'SolrTextSearch', function ($scope, $routeParams, $location, $anchorScroll, $analytics, graph, solr) {

    function newSearch() {
        var queryParams = $location.search();
        var docid = queryParams.docid;
        var options = {};
        if (docid && $scope.search) {
            // If we already have this record loaded, reuse it.
            var source = _.find($scope.search.records, function (r) {
                return r.docid == docid;
            });
            if (source) {
                options.source = source;
            }
        }
        var searcher = docid ? graph : solr;
        return searcher.newSearch(queryParams, options);
    }

    function init(docid) {
        $scope.search = newSearch();
    }

    function updateQueryParams() {
        $location.search($scope.search.getUrlQueryParams());
    }

    $scope.updateUserString = function () {
        $scope.search.updateUserString();
        updateQueryParams();
    };

    $scope.gotoPage = function (page) {
        $scope.search.gotoPage(page);
        updateQueryParams();
        $anchorScroll(); // back to the top!
    };

    $scope.updateFacetSelections = function (facetToSkip) {
        $scope.search.updateFacetSelections(facetToSkip);
        updateQueryParams();
    };

    $scope.topOfPage = $anchorScroll;

    $scope.$on("$routeUpdate", function (event, data) {
        // We've detected a route change - if we did it ourselves, then
        // the params will match. If they differ, this was done by the user,
        // so update the search.
        if (!_.isEqual($location.search(), $scope.search.getUrlQueryParams())) {
            $scope.search = newSearch();
        } else {
            $analytics.pageTrack($location.url());
        }
    });

    init();
}]);
'use strict';

angular.module('huni').controller('SearchController', ['$scope', '$location', function SearchController($scope, $location) {

    function init() {
        $scope.query = "";
    }

    // search
    $scope.search = function () {
        // send us to the new view then do the search
        var search = $scope.query;
        if (search === '') {
            search = '*';
        }
        $location.url('/results?q=' + search);
    };

    init();
}]);
'use strict';

angular.module('huni').controller('SlideshowController', ['$scope', function ($scope) {
    $scope.slideInterval = 4000;
    $scope.slides = [{ image: "images/huni-banner-3.jpg", active: false }, { image: "images/huni-banner-1.jpg", active: false }, { image: "images/huni-banner-2.jpg", active: false }];
}]);
'use strict';

angular.module('huni').controller('TopLevelController', ['$scope', 'EmbeddedMode', 'MyHuniMenuItems', 'UserMgtService', function ($scope, EmbeddedMode, menuItems, userMgtService) {
    $scope.activeSnapIn = undefined;
    $scope.menuItems = menuItems;

    $scope.$on('SnapInStateChangedEvent', function (ev, snapIn) {
        $scope.activeSnapIn = snapIn.isActive ? snapIn : undefined;
        if (snapIn.isActive) {
            $scope.activeSnapIn = snapIn;
        } else {
            $scope.activeSnapIn = undefined;
        }
    });

    $scope.setEmbeddedMode = function () {
        EmbeddedMode.set(true);
    };

    // snapInHeight is used to work out the size of the snap-in, and we watch
    // that function to detect any changes, and adjust the mainview as needed
    var snapIns = ['link-snapin', 'collection-snapin', 'embed-snapin'];
    function snapInHeight() {
        var totalHeight = 0;
        _.each(snapIns, function (id) {
            var element = document.getElementById(id);
            if (element) {
                totalHeight += element.offsetHeight;
            }
        });
        return totalHeight;
    }

    var mainView = document.getElementById('main-view');
    $scope.$watch(snapInHeight, function (newValue, oldValue) {
        mainView.style.marginTop = newValue + 'px';
    });

    $scope.hideMenu = function () {
        $scope.isCollapsed = true;
    };

    function init() {
        userMgtService.loginStatus().then(function (data) {
            $scope.user = data;
        });
    }

    init();
}]);
'use strict';

angular.module('huni').controller('UserController', ['$scope', '$routeParams', 'HuniBackend', 'UserMgtService', function ($scope, $routeParams, huni, userMgt) {

    var user_id = $routeParams.id;

    huni.get('profile/' + user_id).then(function (response) {
        $scope.user = response.data;
        return userMgt.loginStatus();
    }).then(function (user) {
        $scope.own_profile = user.id == $scope.user.id;
    });
}]);
'use strict';

angular.module('huni').directive('collectionButton', function () {

    function link(scope, element, attrs) {

        function isEnabled() {
            // If there is a snapin and it's not the collection snapin,
            // then the button is disabled.
            // If there is no snapin, or that snap is the collection,
            // the the button is enabled.
            return !scope.snapIn || scope.snapIn.name === 'collection';
        }

        function getMode() {
            if (!scope.snapIn) {
                return 'default';
            }
            if (scope.snapIn.name !== 'collection') {
                return 'default';
            }
            if (!scope.record.collections) {
                return 'add';
            }

            // If this record is in the selected collection, then the
            // mode is remove (false), otherwise add.
            return _.has(scope.record.collections, scope.snapIn.selectedCollection.id) ? 'remove' : 'add';
        }

        function refreshState() {
            var isDisabled = !isEnabled();
            if (scope.isDisabled !== isDisabled) {
                scope.isDisabled = isDisabled;
            }

            scope.mode = getMode();
        }

        scope.click = function () {
            scope.$emit('CollectionRecordChangeEvent', scope.record, scope.mode !== 'remove');
        };

        scope.$watch('snapIn', refreshState);
        scope.$watch('record', refreshState);
        scope.$watchCollection('record.collections', refreshState);
        refreshState();
    }

    return {
        restrict: 'E',
        scope: {
            record: '=',
            snapIn: '='
        },
        templateUrl: 'partials/buttons/collection.html',
        link: link
    };
});
'use strict';

angular.module('huni').directive('collectionList', ['$location', 'CollectionRole', 'DialogService', 'HuniBackend', 'UserMgtService', function ($location, collectionRole, dialog, huni, userMgt) {

    function link(scope, element, attr) {
        // directive parameters are stringified(?)
        scope.public = scope.isPublic === 'true';

        if (_.isUndefined(attr.userAlert)) {
            // set a default alert object in case the user hasn't
            attr.userAlert = {};
        }

        function setMessage(type, msg) {
            scope.userAlert.type = type;
            scope.userAlert.message = msg;
        }

        function ok(msg) {
            setMessage('success', msg);
        }
        function error(msg) {
            setMessage('danger', msg);
        }

        scope.roleOptions = collectionRole.options();

        scope.roleName = function (roleId) {
            return collectionRole.getInfo(roleId).name;
        };

        function yesDeleteCollection(c) {
            huni.delete('collection/' + c.id).success(function (response) {
                var index = scope.collections.indexOf(c);
                scope.collections.splice(index, 1);
                ok('Deleted collection "' + c.name + '"');
            }).error(function () {
                error('There was an error deleting collection "' + c.name + '"');
            });
        }

        scope.activateCollection = function (c) {
            var loc = scope.baseUri + '/' + c.id + '/manage';
            if (loc[0] == '#') {
                loc = loc.substring(1);
            }
            $location.url(loc);
        };

        scope.manageCollectionUsers = function (c) {
            var loc = scope.baseUri + '/' + c.id + '/users';
            if (loc[0] == '#') {
                loc = loc.substring(1);
            }
            $location.url(loc);
        };

        // Delete a whole collection
        scope.deleteCollection = function (c) {
            var msg = 'Really delete collection "' + c.name + '"?';
            dialog.confirmationDialog(msg).then(function () {
                yesDeleteCollection(c);
            });
        };

        // This hides collections that were un-published while we were
        // looking at them.
        scope.isVisible = function (collection) {
            var ret = !scope.public || collection.is_public;
            return ret;
        };

        scope.$on('CollectionDetailsEvent', function (e, collection) {
            var oldCollection = _.findWhere(scope.collections, { id: collection.id });
            _.extend(oldCollection, collection);
        });

        scope.canChangeRole = function (collection) {
            if (collection.role_id != 'owner') {
                return false;
            }
            if (collection.owners.length == 1) {
                return false;
            }
            return true;
        };

        function removeRole(collection) {
            var path = '/collection/' + collection.id + '/user/' + scope.user.id;

            return huni.delete(path).then(function (success) {
                ok('Removed "' + collection.name + '" from your collections');
                scope.collections = _.reject(scope.collections, function (i) {
                    return i.id == collection.id;
                });
            }, function (failure) {
                error('There was an error removing "' + collection.name + '" from your collections');
            });
        }

        function changeRole(collection, roleId) {
            var path = '/collection/' + collection.id + '/user/' + scope.user.id + '/' + roleId;
            var desc = collectionRole.getInfo(roleId).description;

            return huni.put(path).then(function (success) {
                ok('You are now ' + desc + ' on collection "' + collection.name + '"');
            }, function (failure) {
                error('There was an error changing you to ' + desc + ' on collection "' + collection.name + '"');
            });
        }

        scope.onRoleChange = function (collection, oldRoleId) {
            var isRemoval = collection.role_id == 'remove';
            var msg = isRemoval ? 'This will remove collection "' + collection.name + '" from your collections.' : 'This will remove your ownership rights from collection "' + collection.name + '".';

            var result = dialog.confirmationDialog(msg + "<br><br>You will not be able to undo this change. Are you sure?");

            result.then(function (ok) {
                if (isRemoval) {
                    removeRole(collection);
                } else {
                    changeRole(collection, collection.role_id);
                }
            }, function (cancel) {
                collection.role_id = oldRoleId;
            });
        };

        scope.permissions = function (collection) {
            return collectionRole.permissions(collection.role_id);
        };

        userMgt.loginStatus().then(function (user) {
            scope.user = user;
        });
    }

    return {
        restrict: 'E',
        scope: {
            baseUri: '@',
            collections: '=',
            isPublic: '@',
            userAlert: '='
        },
        templateUrl: 'partials/directives/collection-list.html',
        link: link
    };
}]);
'use strict';

angular.module('huni').directive('collectionSnapin', ['$rootScope', '$modal', 'CollectionRole', 'HuniBackend', function ($rootScope, $modal, collectionRole, _huniBackend) {

    function updateCollection(dest, src, fields) {
        _.each(fields, function (field) {
            dest[field] = src[field];
        });
    }

    function updateRecord(collection, record, isAdded) {
        return {
            apply: function apply() {
                var method = isAdded ? _huniBackend.put : _huniBackend.delete;
                var uri = 'collection/' + collection.id + '/' + record.docid;
                return method(uri).success(function (result) {
                    collection.record_count = result.record_count;
                    $rootScope.$broadcast('CollectionChangedEvent', {
                        collection: collection,
                        record: record,
                        added: isAdded
                    });
                });
            },
            undo: function undo() {
                return updateRecord(collection, record, !isAdded);
            },
            message: function message(isOk) {
                var verb, ret;
                if (isOk) {
                    verb = isAdded ? 'Added' : 'Removed';
                    ret = verb + ' ' + record.displayName;
                } else {
                    verb = isAdded ? 'add' : 'remove';
                    ret = 'Failed to ' + verb + ' ' + record.displayName;
                }
                return ret;
            }
        };
    }

    function updateIsPublic(collection, is_public) {
        return {
            apply: function apply() {
                var method = _huniBackend.put;
                var uri = 'collection/' + collection.id;
                return method(uri, { is_public: is_public }).success(function (result) {
                    updateCollection(collection, result, ['is_public', 'modified_utc']);
                    $rootScope.$broadcast('CollectionDetailsEvent', collection);
                }).error(function (result) {
                    // Reset the is_public checkbox
                    collection.is_public = !is_public;
                });
            },
            undo: function undo() {
                return updateIsPublic(collection, !is_public);
            },
            message: function message(isOk) {
                var audience = is_public ? 'everyone' : 'you only';
                return isOk ? 'Collection now visible to ' + audience : 'Collection update failed';
            }
        };
    }

    function updateDetails(collection, newDetails) {
        var oldDetails = _.pick(collection, _.keys(newDetails));
        return {
            apply: function apply() {
                var method = _huniBackend.put;
                var uri = 'collection/' + collection.id;
                return method(uri, newDetails).success(function (result) {
                    updateCollection(collection, result, ['name', 'synopsis', 'modified_utc']);
                    $rootScope.$broadcast('CollectionDetailsEvent', collection);
                });
            },
            undo: function undo() {
                return updateDetails(collection, oldDetails);
            },
            message: function message(isOk) {
                return isOk ? 'Collection updated' : 'Collection update failed';
            }
        };
    }

    function link(scope, element, attrs) {

        scope.name = 'collection';
        scope.isActive = false;
        scope.selectedCollection = undefined;
        scope.message = undefined;

        function launchDialog() {
            var modalInstance = $modal.open({
                templateUrl: 'partials/dialogs/choose-collection.html',
                controller: 'ChooseCollectionDialogController',
                resolve: {
                    huniBackend: function huniBackend() {
                        return _huniBackend;
                    }
                }
            });

            return modalInstance.result;
        }

        function doUpdate(update) {
            update.apply().success(function (result) {
                scope.ok = true;
                scope.message = update.message(true);
                scope.undo = update.undo();
            }).error(function (result) {
                scope.ok = false;
                scope.message = update.message(false);
                scope.undo = update;
            });
        }

        function setActive(isActive) {
            if (scope.isActive !== isActive) {
                scope.isActive = isActive;
                $rootScope.$broadcast('SnapInStateChangedEvent', scope);
            }
        }

        function onRecordChange(ev, record, isAdd) {
            if (scope.selectedCollection) {
                var update = updateRecord(scope.selectedCollection, record, isAdd);
                doUpdate(update);
            } else {
                launchDialog().then(function (collection) {
                    setSelectedCollection(collection);
                    setActive(true);
                    onRecordChange(ev, record, isAdd);
                });
            }
        }

        function setSelectedCollection(collection) {
            scope.selectedCollection = collection;
        }

        scope.permissions = function () {
            return scope.selectedCollection ? collectionRole.permissions(scope.selectedCollection.role_id) : {};
        };

        scope.editDetails = function () {
            scope.message = undefined;
            var c = scope.selectedCollection;
            var p = scope.permissions();
            var modalInstance = $modal.open({
                templateUrl: 'partials/dialogs/collection-details.html',
                controller: 'CollectionDetailsDialogController',
                resolve: {
                    collection: function collection() {
                        return c;
                    },
                    permissions: function permissions() {
                        return p;
                    }
                }
            });

            modalInstance.result.then(function (results) {
                var update = updateDetails(c, results);
                doUpdate(update);
            });
        };

        scope.closeAlert = function () {
            scope.message = undefined;
        };

        scope.close = function () {
            scope.selectedCollection = undefined;
            scope.last = {};
            scope.showAlert = false;
            setActive(false);
        };

        scope.undoCollectionOperation = function () {
            doUpdate(scope.undo);
        };

        scope.updateIsPublic = function (value) {
            var c = scope.selectedCollection;
            var update = updateIsPublic(c, c.is_public);
            doUpdate(update);
        };

        $rootScope.$on('CollectionRecordChangeEvent', onRecordChange);
        $rootScope.$on('EditLinkEvent', scope.close);
        $rootScope.$on('EditCollectionEvent', function (ev, collection) {
            setSelectedCollection(collection);
            setActive(true);
        });
    }

    return {
        restrict: 'E',
        scope: {},
        templateUrl: 'partials/snapins/collection.html',
        link: link
    };
}]);
'use strict';

angular.module('huni').directive('embedButton', function () {

    function link(scope, element, attrs) {

        function refreshState() {
            if (!scope.snapIn) {
                // No snapin active
                scope.isEnabled = true;
            } else {
                scope.isEnabled = false;
            }
        }

        scope.$on('EmbedSnapInChangedEvent', refreshState);
        scope.$watch('snapIn', refreshState);
        refreshState();
    }

    return {
        restrict: 'E',
        scope: {
            record: '=',
            snapIn: '='
        },
        templateUrl: 'partials/buttons/embed.html',
        link: link
    };
});
'use strict';

angular.module('huni').directive('embedSnapin', ['$rootScope', '$location', function ($rootScope, $location) {

    function link(scope, element, attrs) {

        scope.isActive = false;
        scope.name = 'embed';

        scope.embedCode = function () {
            var baseURL = location.origin;
            var entityType = scope.record.entityType;
            return '<iframe src="' + baseURL + '/embed#/record/' + scope.record.docid + '"\n    title="' + entityType.toUpperCase() + ': ' + scope.record.displayName + '"\n    height="200" width="300">\n</iframe>';
        };

        scope.copyToClipboard = function () {
            var copyText = scope.embedCode();
            navigator.clipboard.writeText(copyText);
        };

        function setActive(isActive) {
            if (scope.isActive !== isActive) {
                scope.isActive = isActive;
                $rootScope.$broadcast('SnapInStateChangedEvent', scope);
            }
        };

        scope.close = function () {
            setActive(false);
        };

        $rootScope.$on('EmbedEvent', function (ev, record) {
            scope.record = record;
            setActive(true);
        });
    }

    return {
        restrict: 'E',
        scope: {},
        templateUrl: 'partials/snapins/embed.html',
        link: link
    };
}]);
'use strict';

angular.module('huni').directive('exportCollectionButton', ['$location', '$timeout', 'DialogService', 'HuniBackend', 'SolrSearchService', function ($location, $timeout, dialog, huni, solr) {

    function getLocationRoot() {
        var absUrl = $location.absUrl(); // http://host/root/#/a/b?q=3
        var url = $location.url(); //                   /a/b?q=3
        var index = absUrl.indexOf(url);
        if (index < 0) {
            return absUrl;
        }
        return absUrl.substring(0, index);
    }

    function dateString(s) {
        return moment.utc(s).local().format('LLL');
    }

    function mergeRows(metadata, rows) {
        var rowsTransposed = _.zip.apply(_, rows);
        rowsTransposed.unshift(metadata);
        var mergedRows = _.zip.apply(_, rowsTransposed);
        return mergedRows;
    }

    function link(scope, element, attrs) {
        scope.formName = 'exportCollectionForm' + scope.$id;
        scope.exportData = {
            filename: 'collection.csv',
            columns: ['Collection Description', 'Record Name', 'HuNI Record', 'Original Record'],
            rows: []
        };

        function doExportCollection() {
            var c = scope.collection;
            var baseUri = getLocationRoot() + '/record/';
            var form = document.forms[scope.formName];
            var date = moment().format('YYYYMMDD-hhmmss');
            huni.get('publication/' + c.id).then(function (resp) {
                return _.pluck(resp.data.records, 'docid');
            }).then(solr.getRecords).then(function (records) {
                // We now have all the data we need for the export.
                // Fill in the data in the exportCollection form, and
                // then trigger the form submission.
                scope.exportData.filename = 'huni-export-' + date + '.csv';

                var dataRows = _.map(records, function (r) {
                    return [r.displayName, baseUri + r.docid, r.sourceRecordLink || ''];
                });
                var collectionPath = c.is_public ? '/collection/' : '/myhuni/collection/';
                var metadata = ['Collection name: ' + c.name || '', 'Created by: ' + c.username || '', 'Description: ' + (c.synopsis || '(none)'), 'Created: ' + dateString(c.created_utc), 'Last modified: ' + dateString(c.modified_utc), 'Collection URL: ' + getLocationRoot() + collectionPath + c.id];

                scope.exportData.rows = mergeRows(metadata, dataRows);

                // We've set the scope.exportData variables, but the
                // bindings in the exportCollection form have not yet
                // been updated. We cannot call scope.$update() as we
                // are already in an update. Instead we use $timeout
                // with a zero delay - it will fire once the $update is
                // complete (by then the bindings will be up-to-date).
                $timeout(function () {
                    form.submit();
                });
            }).catch(function () {
                error('There was an error exporting collection "' + c.name + '"');
            });
        }

        function exportCollection() {
            dialog.licenceDialog().then(doExportCollection);
        }

        // This stops you doing multiple exports accidentally
        scope.exportCollection = _.debounce(exportCollection, 300);
    }

    return {
        restrict: 'E',
        scope: {
            collection: '='
        },
        templateUrl: 'partials/buttons/export-collection.html',
        link: link
    };
}]);
'use strict';

angular.module('huni').directive('graphViewButton', ['$location', function ($location) {

    function link(scope, element, attrs) {
        scope.click = function () {
            $location.path('/record/' + scope.docid);
        };
    }

    return {
        restrict: 'E',
        scope: {
            docid: '='
        },
        templateUrl: 'partials/buttons/graph-view.html',
        link: link
    };
}]);
'use strict';

angular.module('huni').directive('huniAlert', function () {
    return {
        restrict: 'EA',
        templateUrl: 'partials/directives/huni-alert.html',
        transclude: true,
        replace: true,
        scope: {
            type: '=',
            close: '&'
        }
    };
});
'use strict';

angular.module('huni').directive('linkButton', function () {

    function link(scope, element, attrs) {

        function linkAlreadyExists() {
            var snap = scope.snapIn;
            return _.find(scope.record.links, function (link) {
                return snap.link.user_id === link.user_id && snap.fromRecord.docid === link.to_docid && snap.rw.selectedRHS.id === link.pairtype_id;
            });
        }

        function refreshState() {
            if (!scope.snapIn) {
                // No snapin active
                scope.isEnabled = true;
                scope.canComplete = false;
            } else if (scope.snapIn.name !== 'link') {
                // Some other snapin is active
                scope.isEnabled = false;
                scope.canComplete = false;
            } else if (scope.snapIn.fromRecord.docid === scope.record.docid) {
                // This record is selected as the 'from' record
                scope.isEnabled = false;
                scope.canComplete = false;
            } else if (!scope.snapIn.toRecord) {
                // The second record has not been selected.
                scope.isEnabled = true;
                scope.canComplete = true;
            } else if (scope.snapIn.toRecord.docid === scope.record.docid) {
                // This record is selected as the second 'from' record
                scope.isEnabled = false;
                scope.canComplete = false;
            } else if (scope.snapIn.form.$dirty) {
                // Both records are selected in the snapin, but it hasn't
                // been saved.
                scope.isEnabled = false;
                scope.canComplete = false;
            } else if (linkAlreadyExists()) {
                // There already exists a link between the source record
                // and this record using the selected relationship.
                scope.isEnabled = false;
                scope.canComplete = false;
            } else {
                scope.isEnabled = true;
                scope.canComplete = true;
            }
        }

        scope.$on('LinkSnapInChangedEvent', refreshState);
        scope.$watch('snapIn', refreshState);
        scope.$watch('record', refreshState);
        scope.$watch('record.links', refreshState);
        refreshState();
    }

    return {
        restrict: 'E',
        scope: {
            record: '=',
            snapIn: '='
        },
        templateUrl: 'partials/buttons/link.html',
        link: link
    };
});
'use strict';

angular.module('huni').directive('linkSnapin', ['$rootScope', '$modal', 'DialogService', 'HuniBackend', function ($rootScope, $modal, dialog, _huniBackend) {

    var createNew = { name: 'Create new...', pair: 'Create new...' };

    var messages = {
        new1: ['Step One', 'Choose another record to link with. ' + 'You can navigate wherever you like to find other records. ' + 'For example start a new search, interact with a network graph, ' + 'or view a collection.'],

        new2: ['Step Two', 'Select a relationship'],

        new3: ['Step Three', 'Add a note and save your link'],

        new4: ['Link Created', 'Close this window or keep editing'],

        dirty: ['Unsaved Changes', 'Your link has unsaved changes'],

        clean: ['Link Saved', 'Your link is up to date'],

        duplicate: ['Link already exists', "You've already created this link", true],

        failed: ['Save failed', 'Something went wrong. Try saving again', true]
    };

    function link(scope, element, attrs) {

        scope.isActive = false;
        scope.name = 'link';
        scope.showAlert = true;
        scope.lastMessageCode = '';
        scope.errorCode = '';

        function getAlertMessageCode() {
            if (scope.errorCode) {
                return scope.errorCode;
            }
            if (!scope.toRecord) {
                return 'new1';
            }
            if (!scope.rw.selectedLHS) {
                return 'new2';
            }
            if (!scope.rw.selectedRHS) {
                return 'new2';
            }
            if (scope.link) {
                // editing an existing link
                return scope.form.$dirty ? 'dirty' : 'clean';
            }
            // creating a new link
            return scope.form.$dirty ? 'new3' : 'new4';
        }

        scope.getAlertMessage = function () {
            var code = getAlertMessageCode();
            var msg = messages[code];
            if (scope.lastMessageCode !== code) {
                scope.showAlert = true;
                scope.lastMessageCode = code;
                scope.alertType = msg[2] ? 'danger' : 'success';
            }
            return '<strong>' + msg[0] + ' </strong>' + '<em>' + msg[1] + ' </em>';
        };

        // Add a linktype.display member which disambiguates one-to-many
        // linktypes. eg. parent / (child/son/daughter)
        function annotateLinktypes(linktypes) {
            var pairList = _.groupBy(linktypes, 'name');
            var links = [];
            _.each(pairList, function (pairs, name) {
                pairs = _.sortBy(pairs, 'pair');
                pairs.push(createNew);
                links.push({
                    name: name,
                    pairs: pairs
                });
            });
            links.push(createNew);
            return links;
        }

        function setActive(isActive) {
            if (scope.isActive !== isActive) {
                scope.isActive = isActive;
                $rootScope.$broadcast('SnapInStateChangedEvent', scope);
            }
        }

        function reset() {
            scope.link = undefined; // set=edit, undef=new
            scope.fromRecord = undefined;
            scope.toRecord = undefined;
            scope.rawLinks = [];
            scope.linktypes = [];
            scope.errorCode = '';
            scope.rw = {
                // XXX: why is the html using a sub-scope?
                selectedLHS: undefined,
                selectedRHS: undefined,
                pairs: [],
                linknote: ''
            };
            setActive(false);
            window.onbeforeunload = null;
        }

        function launchLinktypeDialog(_lhsName) {
            var modalInstance = $modal.open({
                templateUrl: 'partials/dialogs/create-linktype.html',
                controller: 'CreateLinktypeDialogController',
                resolve: {
                    huniBackend: function huniBackend() {
                        return _huniBackend;
                    },
                    fromRecord: function fromRecord() {
                        return scope.fromRecord;
                    },
                    toRecord: function toRecord() {
                        return scope.toRecord;
                    },
                    suggestions: function suggestions() {
                        return scope.linktypes;
                    },
                    lhsName: function lhsName() {
                        return _lhsName;
                    }
                }
            });

            return modalInstance.result;
        }

        function launchLinkNoteDialog() {
            var modalInstance = $modal.open({
                templateUrl: 'partials/dialogs/link-note.html',
                controller: ['$scope', function ($scope) {
                    $scope.linknote = scope.rw.linknote;
                }]
            });

            return modalInstance.result;
        }

        function updateLinkTypes() {
            var uri = 'linktype/' + scope.fromRecord.entityType + '/' + scope.toRecord.entityType;
            return _huniBackend.get(uri).success(function (data) {
                scope.rawLinks = data;
                scope.linktypes = annotateLinktypes(scope.rawLinks);
            });
        }

        function addRecord(record) {
            if (_.isUndefined(scope.fromRecord)) {
                scope.fromRecord = record;
                setActive(true);
            } else if (_.isUndefined(scope.toRecord)) {
                scope.toRecord = record;
                updateLinkTypes();
            } else {
                var keepLinkTypes = scope.toRecord.entityType === record.entityType;

                scope.link = undefined;
                scope.toRecord = record;
                if (!keepLinkTypes) {
                    scope.rw.selectedLHS = undefined;
                    scope.rw.selectedRHS = undefined;
                    updateLinkTypes();
                }
            }
            scope.form.$setDirty();
            $rootScope.$broadcast('LinkSnapInChangedEvent');
        }

        function editLink(link) {
            scope.link = link;
            scope.fromRecord = link.from;
            scope.toRecord = link.to;
            scope.rawLinks = [];
            scope.linktypes = [];
            scope.rw.pairs = [];
            scope.rw.linknote = link.synopsis;
            scope.rw.selectedLHS = undefined;
            scope.rw.selectedRHS = undefined;
            updateLinkTypes().then(function () {
                scope.rw.selectedLHS = _.findWhere(scope.linktypes, { name: link.linktype });
                scope.rw.selectedRHS = _.findWhere(scope.rw.selectedLHS.pairs, { pair: link.pairtype });
            });
            scope.form.$setPristine();
            $rootScope.$broadcast('LinkSnapInChangedEvent');
            setActive(true);
        }

        scope.lhsChanged = function () {
            scope.errorCode = '';
            if (scope.rw.selectedLHS === createNew) {
                // User chose 'Create new...'
                scope.rw.selectedLHS = undefined;
                scope.createLinktype();
            } else if (scope.rw.selectedLHS) {
                // User chose a valid choice
                scope.rw.selectedRHS = scope.rw.selectedLHS.pairs[0];
            } else {
                // User moved back to '-- select a relationship --'
                scope.rw.selectedRHS = undefined;
            }
            $rootScope.$broadcast('LinkSnapInChangedEvent');
        };

        scope.rhsChanged = function () {
            scope.errorCode = '';
            if (scope.rw.selectedRHS === createNew) {
                var lhsName = scope.rw.selectedLHS.name;
                scope.rw.selectedLHS = undefined;
                scope.createLinktype(lhsName);
            }
            $rootScope.$broadcast('LinkSnapInChangedEvent');
        };

        scope.createLinktype = function (lhsName) {
            scope.errorCode = '';
            launchLinktypeDialog(lhsName).then(function (linktype) {
                scope.rawLinks.push(linktype);
                scope.linktypes = annotateLinktypes(scope.rawLinks);
                scope.rw.selectedLHS = _.findWhere(scope.linktypes, { name: linktype.name });
                scope.rw.selectedRHS = _.findWhere(scope.rw.selectedLHS.pairs, { pair: linktype.pair });
            });
        };

        scope.editNote = function () {
            scope.errorCode = '';
            launchLinkNoteDialog().then(function (linknote) {
                if (scope.rw.linknote !== linknote) {
                    scope.rw.linknote = linknote;
                    scope.form.$setDirty();
                }
            });
        };

        scope.saveLink = function () {
            scope.errorCode = '';
            var data = {
                from_docid: scope.fromRecord.docid,
                to_docid: scope.toRecord.docid,
                linktype_id: scope.rw.selectedRHS.id,
                synopsis: scope.rw.linknote
            };
            var promise;
            var action;
            if (scope.link) {
                // Editing existing link
                promise = _huniBackend.put('link/' + scope.link.id, data);
                action = 'modified';
            } else {
                // Creating new link
                promise = _huniBackend.post('link', data);
                action = 'created';
            }
            promise.success(function (link) {
                scope.link = link;
                $rootScope.$broadcast('LinkChangedEvent', {
                    link: link,
                    action: action
                });
                scope.form.$setPristine();
                $rootScope.$broadcast('LinkSnapInChangedEvent');
            }).error(function (response, code) {
                if (code == 400) {
                    scope.form.$setPristine(); // we are clean now
                    scope.errorCode = 'duplicate';
                } else {
                    scope.errorCode = 'failed';
                }
            });
        };

        scope.close = function (ask) {
            if (ask && scope.isActive) {
                dialog.confirmationDialog('Really close without saving?').then(reset);
            } else {
                reset();
            }
        };

        scope.closeAlert = function () {
            scope.showAlert = false;
        };

        reset();
        $rootScope.$on('AddRecordToLinkEvent', function (ev, record) {
            addRecord(record);
        });
        $rootScope.$on('EditLinkEvent', function (ev, link) {
            editLink(link);
        });
        $rootScope.$on('EditCollectionEvent', scope.close);

        window.onbeforeunload = function () {
            if (!scope.form.$dirty) {
                return;
            }
            return 'Your link has not been saved';
        };
    }

    return {
        restrict: 'E',
        scope: {},
        templateUrl: 'partials/snapins/link.html',
        link: link
    };
}]);
'use strict';

angular.module('huni').directive('loadingStatus', ['$timeout', function ($timeout) {

    var defaultMessage = {
        empty: "Sorry. We're unable to locate what you're looking for.",
        error: "Sorry. We've crashed!",
        loading: "Please wait. We're just loading your request."
    };

    function link(scope, element, attrs) {
        // Update any missing message attributes with the defaults.
        _.each(defaultMessage, function (msg, key) {
            var sym = key + 'Message';
            attrs[sym] = attrs[sym] || msg;
        });
    }

    var scope = {
        status: '='
    };
    // Create the message attributes eg. scope.emptyMessage = '@'
    _.each(_.keys(defaultMessage), function (key) {
        scope[key + 'Message'] = '@';
    });

    return {
        link: link,
        restrict: 'E',
        scope: scope,
        templateUrl: 'partials/directives/loading-status.html'
    };
}]);
'use strict';

angular.module('huni').directive('loginButton', ['$location', '$route', 'UserMgtService', function ($location, $route, userMgt) {

    function link(scope) {

        function login() {
            // Go to the login page, with our current location as the redirect
            var redir = $location.absUrl();
            $location.path('/login').search({ r: redir });
        }

        function logout() {
            userMgt.logout().then(function (ok) {
                $location.path('/');
            });
        }

        scope.click = function () {
            if (scope.user.loggedIn) {
                logout();
            } else {
                login();
            }
        };
    }

    return {
        restrict: 'E',
        scope: {
            user: '='
        },
        templateUrl: 'partials/buttons/login.html',
        link: link
    };
}]);
'use strict';

angular.module('huni').directive('myHuniPills', ['$timeout', 'MyHuniMenuItems', function ($timeout, items) {

    function link(scope) {
        var alertLevel = 0;
        var alertTimeoutMillis = 5000;

        scope.items = items;
        scope.alertTypes = ['success', 'warning', 'danger', 'info'];
        scope.displayMessage = '';

        scope.isActive = function (tabName) {
            return tabName === scope.activeTab ? "active" : "";
        };

        scope.$watch('userAlert.message', function (newValue, oldValue) {
            if (_.isUndefined(newValue)) {
                // We got here because we set alertMessage to undefined
                // ourselves. Ignore this case.
                return;
            }
            //
            // Immediately clear the incoming message to that we detect when
            // the client sets it again, even if it is the same message.
            scope.userAlert.message = undefined;

            // Set the message which is actually displayed to the incoming
            // message.
            scope.displayMessage = newValue;

            alertLevel += 1;
            $timeout(function () {
                alertLevel -= 1;
                if (alertLevel === 0) {
                    scope.displayMessage = undefined;
                }
            }, alertTimeoutMillis);
        });

        scope.closeAlert = function () {
            scope.displayMessage = '';
        };
    }

    return {
        restrict: 'E',
        link: link,
        scope: {
            activeTab: '@',
            userAlert: '='
        },
        templateUrl: 'partials/directives/myhuni-pills.html'
    };
}]);
'use strict';

angular.module('huni').directive('queryButton', function () {

    function link(scope, element, attrs) {

        function linkAlreadyExists() {
            var snap = scope.snapIn;
            return _.find(scope.record.links, function (link) {
                return snap.link.user_id === link.user_id && snap.fromRecord.docid === link.to_docid && snap.rw.selectedRHS.id === link.pairtype_id;
            });
        }

        function refreshState() {
            if (!scope.snapIn) {
                // No snapin active
                scope.isEnabled = true;
                scope.canComplete = false;
            } else if (scope.snapIn.name !== 'query') {
                // Some other snapin is active
                scope.isEnabled = false;
                scope.canComplete = false;
            } else if (scope.snapIn.fromRecord.docid === scope.record.docid) {
                // This record is selected as the 'from' record
                scope.isEnabled = false;
                scope.canComplete = false;
            } else if (scope.snapIn.toRecord && scope.snapIn.toRecord.docid === scope.record.docid) {
                // This record is selected as the 'to' record
                scope.isEnabled = false;
                scope.canComplete = false;
            } else {
                scope.isEnabled = true;
                scope.canComplete = true;
            }
        }

        scope.$on('QuerySnapInChangedEvent', refreshState);
        scope.$watch('snapIn', refreshState);
        scope.$watch('record', refreshState);
        scope.$watch('record.links', refreshState);
        refreshState();
    }

    return {
        restrict: 'E',
        scope: {
            record: '=',
            snapIn: '='
        },
        templateUrl: 'partials/buttons/query.html',
        link: link
    };
});
'use strict';

angular.module('huni').directive('querySnapin', ['$rootScope', '$location', function ($rootScope, $location) {

    function link(scope, element, attrs) {

        scope.isActive = false;
        scope.name = 'query';

        function setActive(isActive) {
            if (scope.isActive !== isActive) {
                scope.isActive = isActive;
                $rootScope.$broadcast('SnapInStateChangedEvent', scope);
            }
        }

        function reset() {
            scope.fromRecord = undefined;
            scope.errorCode = '';
            setActive(false);
            window.onbeforeunload = null;
        }

        function addRecord(record) {
            if (_.isUndefined(scope.fromRecord)) {
                scope.fromRecord = record;
                setActive(true);
                $rootScope.$broadcast('QuerySnapInChangedEvent');
            } else {
                findShortestPath(record);
            }
        }

        function findShortestPath(toRecord) {
            // Use url() here not path() as we want to blow away any query
            // parameters.
            var from = scope.fromRecord.docid;
            var to = toRecord.docid;
            $location.url('/record/' + from + '/' + to);
            reset();
        };

        scope.findReachableNodes = function () {
            var docid = scope.fromRecord.docid;
            $location.search({ docid: docid });
            $location.path('/results');
            reset();
        };

        scope.close = function () {
            reset();
        };

        reset();
        $rootScope.$on('AddRecordToQueryEvent', function (ev, record) {
            addRecord(record);
        });
        $rootScope.$on('EditCollectionEvent', scope.close);
    }

    return {
        restrict: 'E',
        scope: {},
        templateUrl: 'partials/snapins/query.html',
        link: link
    };
}]);
'use strict';

angular.module('huni').directive('recordCount', function () {
    return {
        restrict: 'E',
        scope: {
            count: '@'
        },
        templateUrl: 'partials/directives/record-count.html'
    };
});
'use strict';

angular.module('huni').directive('record', ['EmbeddedMode', function (EmbeddedMode) {
    function link(scope) {
        scope.embedded = EmbeddedMode.get();

        scope.$on('CollectionChangedEvent', function (event, data) {
            if (data.record.docid !== scope.record.docid) {
                return; // not this record
            }

            var collection = data.collection;
            if (data.added) {
                scope.record.collections[collection.id] = collection;
            } else {
                delete scope.record.collections[collection.id];
            }
        });

        function swap(obj, fieldA, fieldB) {
            var t = obj[fieldA];
            obj[fieldA] = obj[fieldB];
            obj[fieldB] = t;
            return obj;
        }

        scope.$on('LinkChangedEvent', function (event, data) {
            var newLink;
            if (data.link.from_docid === scope.record.docid) {
                // This record is the 'from' doc in this link.
                newLink = data.link;
            } else if (data.link.to_docid === scope.record.docid) {
                // This record is the 'to' doc in this link.
                // We need to reverse the link.
                newLink = _.clone(data.link);

                swap(newLink, 'to_docid', 'from_docid');
                swap(newLink, 'linktype_id', 'pairtype_id');
                swap(newLink, 'linktype', 'pairtype');
            } else {
                // Not this record.
                return;
            }

            if (data.action === 'created') {
                if (_.has(scope.record, 'links')) {
                    scope.record.links.push(newLink);
                }
                if (_.has(scope.record, 'linkCount')) {
                    scope.record.linkCount++;
                }
            } else if (data.action === 'deleted') {
                if (_.has(scope.record, 'links')) {
                    scope.record.links = _.reject(scope.record.links, function (test) {
                        return test.id === newLink.id;
                    });
                }
                if (_.has(scope.record, 'linkCount')) {
                    scope.record.linkCount--;
                }
            } else {
                var oldLink = _.find(scope.record.links, function (test) {
                    return test.id === newLink.id;
                });
                if (oldLink) {
                    _.extend(oldLink, newLink);
                }
            }
        });

        scope.isCollection = function () {
            return scope.record.entityType === 'Collection' || scope.record.sourceAgencyCode === 'HuNI';
        };

        scope.hasCollections = function (record) {
            return !_.isEmpty(record.collections);
        };

        scope.hasLinks = function (record) {
            return !_.isEmpty(record.links);
        };

        scope.sortedCollections = function (record) {
            return _.sortBy(record.collections, function (coll) {
                return coll.name.toLowerCase();
            });
        };

        scope.collectionUri = function (collection) {
            // We don't need to know the relationship between the user and
            // the collection. We assume that if they can see it, then either
            // it's public, or the user has some role on that collection.
            // If the collection is public, send them to the public link,
            // otherwise the private one. If they don't have access to the
            // private one the backend will stop them.
            var prefix = collection.is_public ? '#' : '#/myhuni';
            return prefix + '/collection/' + collection.id;
        };

        scope.selectLink = function (docid) {
            scope.$emit('RecordSelectedEvent', docid);
        };

        scope.viewLink = function (link) {
            scope.$emit('ViewLinkEvent', link);
        };

        scope.highlightLink = function (link, isHighlighted) {
            scope.$emit('HighlightLinkEvent', link, isHighlighted);
        };

        // We want to only list maxMentions of these, with an extra line
        // underneath saying "and 3 more".
        // But if we would be saying "and 1 more" we might as well just show it.
        scope.maxMentions = 3;
        scope.mentionsToShow = function (record) {
            if (!record.mentions) {
                return 0;
            }
            if (!scope.brief) {
                return record.mentions.length;
            }
            // We add 1 in the test to avoid the "and 1 more" case
            if (record.mentions.length > scope.maxMentions + 1) {
                return scope.maxMentions;
            } else {
                return record.mentions.length;
            }
        };

        scope.mentionLink = function (mention) {
            // mentions are like: name: "... context ..."
            var rest = mention.indexOf(': "...');
            var name = mention.substring(0, rest);
            var context = mention.substring(rest);

            return '<a href="#/results?q=' + encodeURI(name) + '">' + name + '</a>' + context;
        };
    }

    return {
        restrict: 'E',
        scope: {
            record: '=',
            snapIn: '=',
            brief: '@',
            user: '='
        },
        templateUrl: 'partials/directives/record.html',
        link: link
    };
}]);
'use strict';

angular.module('huni').directive('recordList', ['HuniBackend', function (huniBackend) {

    function link(scope) {

        function getInfoForRecords(records) {
            // Split the docids into actual records and collections.
            var prefix = 'HuNI***Collection***';
            var part = _.chain(records).pluck('docid').partition(function (id) {
                return id.indexOf(prefix) == 0;
            }).value();
            var collection_ids = _.map(part[0], function (id) {
                return id.substr(prefix.length);
            });
            var record_ids = part[1];

            if (record_ids.length > 0) {
                huniBackend.get('record/collection', { d: record_ids }).success(function (collections) {
                    _.each(records, function (r) {
                        var c = collections[r.docid];
                        r.collections = _.indexBy(c, 'id');
                    });
                });
                huniBackend.get('record/link', { d: record_ids }).success(function (linkCount) {
                    _.each(records, function (r) {
                        r.linkCount = linkCount[r.docid] || 0;
                    });
                });
            }
            if (collection_ids.length > 0) {
                huniBackend.get('publication/count', { c: collection_ids }).success(function (collections) {
                    _.each(records, function (r) {
                        var id = r.docid.substr(prefix.length);
                        var c = collections[id];
                        if (c) {
                            _.extend(r, c);
                        }
                    });
                });
            }
        }

        scope.$watch('records', function (newValue, oldValue) {
            // whoops!
            var records = newValue;
            if (!_.isEmpty(records)) {
                getInfoForRecords(records);
            }
        });
    }

    return {
        restrict: 'E',
        scope: {
            records: '=',
            snapIn: '=',
            user: '='
        },
        templateUrl: 'partials/directives/record-list.html',
        link: link
    };
}]);
'use strict';

angular.module('huni').directive('recordMini', function () {
    return {
        replace: true,
        restrict: 'E',
        scope: {
            record: '='
        },
        templateUrl: 'partials/directives/record-mini.html'
    };
});
'use strict';

angular.module('huni').directive('recordSummary', function () {
    return {
        restrict: 'E',
        scope: {
            record: '='
        },
        templateUrl: 'partials/directives/record-summary.html'
    };
});
'use strict';

angular.module('huni').directive('user', [function () {

    function link(scope, element, attr) {}

    return {
        restrict: 'E',
        scope: {
            user: '='
        },
        templateUrl: 'partials/directives/user.html',
        link: link
    };
}]);
'use strict';

angular.module('huni').directive('userList', [function () {

    function link(scope, element, attr) {}

    return {
        restrict: 'E',
        scope: {
            users: '='
        },
        templateUrl: 'partials/directives/user-list.html',
        link: link
    };
}]);
'use strict';

angular.module('huni').directive('userListShort', [function () {

    function link(scope, element, attr) {
        var numberNames = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];

        function number(n) {
            return numberNames[n] || n;
        }

        function formatList(names) {
            if (names.length == 1) {
                return names[0];
            }

            var last = names.pop();
            return names.join(', ') + ' and ' + last;
        }

        scope.text = function () {
            // 1: A
            // 2: A & B
            // 3: A, B & C
            // 4: A, B & n-2 others
            var names = _.pluck(scope.users, 'name');
            if (names.length >= 4) {
                var others = names.length - 2;
                names.splice(2, others, number(others) + ' others');
            }
            return formatList(names);
        };

        scope.title = function () {
            var names = _.pluck(scope.users, 'name');
            return formatList(names);
        };
    }

    return {
        restrict: 'E',
        scope: {
            users: '=',
            link: '@'
        },
        templateUrl: 'partials/directives/user-list-short.html',
        link: link
    };
}]);
'use strict';

angular.module('huni').constant('cfg', {
    url: '/vlab',
    solr: '/solr'
});
'use strict';

angular.module('huni').filter('isNonEmpty', function () {
    // Returns true if this will result in /something/ being displayed
    return function (input) {

        if (input === "None") {
            return false;
        }
        if (input === undefined) {
            return false;
        }
        if (input === null) {
            return false;
        }
        if (input.trim().length === 0) {
            return false;
        }

        return true;
    };
});
'use strict';

angular.module('huni').filter('join', function () {
    // Take an array and a separator, and return the array elements joined by
    // separator.
    return function (input, sep) {
        if (!_.isArray(input)) {
            return input;
        }
        if (_.isUndefined(sep)) {
            sep = ', ';
        }
        return input.join(sep);
    };
});
'use strict';

angular.module('huni').filter('localDate', function () {
    // Take a UTC date as input and return a human-friendly local date/time
    moment.locale('en', {
        calendar: {
            lastDay: '[Yesterday at] LT',
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            lastWeek: '[Last] dddd [at] LT',
            nextWeek: 'dddd [at] LT',
            sameElse: 'dddd, LL'
        },
        longDateFormat: {
            LT: "h:mm A",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY LT",
            LLLL: "dddd, D MMMM YYYY LT"
        }
    });
    return function (dateString) {
        return moment.utc(dateString).local().calendar();
    };
});
'use strict';

angular.module('huni').filter('matchLookahead', function () {

    /*
        This filter is used as a typeahead filter.
    
        It takes a userString and a suggestionArray, and returns a filtered
        version of suggestionArray, including only those that 'match' the
        suggestion.
    
        The old way was to do an exact substring match.
    
        This approach is slightly different. Rather than matching the whole
        user string, it is instead split into words (userWords).
    
        If any of those words match, we accept the suggestion.
    
        eg. If the user string is:  'was marr'
    
        Then these suggestions are all accepted:
    
            'is married'
            'was born'
            'never married'
    
        The idea is somewhat similar to stopword filtering. The intention is
        that by typing 'is married' the user doesn't miss out on 'married to'.
    */

    function isSubstring(needle, haystack) {
        return haystack.indexOf(needle) >= 0;
    }

    return function (suggestionArray, userString) {
        var userWords = userString.trim().toLowerCase().split(/ +/);
        function isCandidate(suggestion) {
            var lcSuggestion = suggestion.toLowerCase();
            return _.find(userWords, function (userWord) {
                return isSubstring(userWord, lcSuggestion);
            });
        }
        return _.filter(suggestionArray, function (suggestion) {
            return isCandidate(suggestion);
        });
    };
});
'use strict';

angular.module('huni').filter('pluck', function () {
    // Take an array of objects and a key, and return an array of the
    // corresponding values.
    return function (input, key) {
        if (!_.isArray(input)) {
            return input;
        }
        return _.pluck(input, key);
    };
});
'use strict';

angular.module('huni').filter('recordClass', function () {
    // Takes a record as input and returns an icon for that record
    return function (input) {
        if (!input) {
            return '';
        }

        var entityType = input.entityType;

        if (!entityType) {
            // Oh crap what's going on here?
            // I think I know. This filter gets executed twice. Once at page
            // load, and once after the results come in. This case is for
            // the initial load.
            entityType = '';
        }

        // Hack - substitute fake collection icon for huni collections.
        if (input.sourceAgencyCode === 'HuNI') {
            entityType = "collection";
        }
        return entityType.toLowerCase();
    };
});
'use strict';

angular.module('huni').filter('recordName', function () {
    // Takes a record as input and returns a title for that record
    // TODO: do this as a post-process harvest step
    return function (input) {
        if (!input) {
            return '';
        }

        return input.displayName;
    };
});
'use strict';

angular.module('huni').filter('sort', function () {
    function case_insensitive(lhs, rhs) {
        return lhs.toLowerCase().localeCompare(rhs.toLowerCase());
    }

    // Take an array as input and returns the sorted array
    return function (input) {
        if (!_.isArray(input)) {
            return input;
        }
        return input.sort(case_insensitive);
    };
});
'use strict';

angular.module('huni').filter('truncate', function () {
    // Truncates the input text on word boundaries
    return function (input, maxLength, isDisabled) {
        if (isDisabled || input === undefined || input === null || input.length <= maxLength) {
            return input;
        }

        while (input[maxLength] !== ' ') {
            maxLength += 1;
            if (maxLength === input.length) {
                return input;
            }
        }

        return input.substr(0, maxLength) + '...';
    };
});
'use strict';

angular.module('huni').filter('trust', ['$sce', function ($sce) {
    return function (text) {
        return $sce.trustAsHtml(text);
    };
}]);
'use strict';

angular.module('huni').filter('values', function () {
    // Take a hash, and return an array of the values.
    return function (input) {
        return _.values(input);
    };
});
'use strict';

angular.module('huni').filter('weblink', function () {
    // Take a weblink as input and adds http:// if necessary
    return function (input) {
        if (_.isUndefined(input) || input.match(/^[a-z]*:\/\//i)) {
            return input;
        }

        return 'http://' + input;
    };
});
"use strict";

angular.module("huni").run(["$templateCache", function ($templateCache) {
  $templateCache.put("partials/404.html", "<div class=\"col-lg-12 col-md-12 col-sm-12\"><div class=\"huni-status huni-status-empty\"><h3>Sorry. We\'re unable to locate what you\'re looking for.</h3><img src=images/bees/hurting.png></div></div>");
  $templateCache.put("partials/about.html", "<div ng-include=\"\'vlab/cms/about-page\'\"></div>");
  $templateCache.put("partials/bibliography.html", "<div ng-include=\"\'vlab/cms/bibliography-page\'\"></div>");
  $templateCache.put("partials/cms.html", "<div><div class=\"row top-space\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><h2>CMS Editor</h2><form class=form-inline><h5 class=inline>Page</h5><select class=form-control ng-model=selectedDoc ng-disabled=modified title=\"Select a Page to Edit\" ng-options=\"doc for doc in documents\"></select><button class=\"btn btn-primary\" type=button ng-click=save() title=\"Save Changes\" ng-disabled=!modified>Save</button> <button class=\"btn btn-danger\" type=button ng-click=revert() title=\"Revert Changes\" ng-disabled=!modified>Revert</button><div class=btn-group dropdown auto-close=always><button id=history-button type=button class=\"btn btn-info\" dropdown-toggle>History <span class=caret></span></button><ul class=dropdown-menu role=menu aria-labelledby=history-button><li role=menuitem ng-repeat=\"v in history\"><a ng-click=revertTo(v.version)>v{{v.version}}: {{v.created_utc | localDate}}</a></li></ul></div></form></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><huni-alert class=myhuni-alert type=alertType ng-if=alertMessage close=closeAlert()>{{alertMessage}}</huni-alert></div></div><div class=\"row top-space\"><div class=\"col-lg-12 col-md-12 col-sm-12\"><summernote config=options ng-model=content></summernote></div></div></div>");
  $templateCache.put("partials/collection.html", "<div class=row ng-if=!isPublic><my-huni-pills active-tab=collections user-alert=userAlert></my-huni-pills></div><hr ng-if=!isPublic><div class=\"col-lg-12 col-md-12 col-sm-12 single-collection\"><div ng-show=\"status===\'ok\'\"><div class=pull-right><graph-view-button docid=collection.docid><export-collection-button collection=collection></export-collection-button></graph-view-button></div><h2><span ng-show=isPublic>Public Collection:</span> <a href=#/record/{{collection.docid}}>{{collection.name}}</a></h2><table class=collection-info><tr><th scope=row>Owners</th><td><user-list users=collection.owners></user-list></td></tr><tr ng-if=!isPublic><th scope=row>Editors</th><td><user-list users=collection.editors></user-list></td></tr><tr ng-if=!isPublic><th scope=row>Viewers</th><td><user-list users=collection.viewers></user-list></td></tr><tr><th scope=row>Last Updated</th><td>{{collection.modified_utc | localDate}}</td></tr><tr><th scope=row>Created</th><td>{{collection.created_utc | localDate}}</td></tr><tr ng-show=\"collection.synopsis | isNonEmpty\"><th scope=row>Notes</th><td>{{collection.synopsis}}</td></tr></table><h3 ng-hide=collection.records.length>No records in collection</h3></div></div><div class=\"col-lg-12 col-md-12 col-sm-12\"><loading-status status=status empty-message=\"Collection not found\"></loading-status><record-list records=collection.records snap-in=activeSnapIn logged-in=user.loggedIn user=user></record-list></div>");
  $templateCache.put("partials/collections.html", "<div><div class=\"row top-space\"><div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12\"><h2>Public Collections</h2><div ng-include=\"\'vlab/cms/collections\'\"></div></div><div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\"><form ng-submit=updateSearchTerm() class=\"input-group pull-right\"><input type=text class=form-control ng-model=data.searchTerm autofocus> <span class=input-group-btn><button class=\"btn btn-primary\" type=submit>Search!</button></span></form></div></div><div class=\"row top-space\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><loading-status status=status empty-message=\"No collections found\" error-message=\"There was an error loading the collections\" loading-message=\"Loading the collections\"></loading-status><collection-list collections=collections base-uri=#/collection is-public=true></collection-list><pagination ng-show=collections.length total-items=data.total class=pull-right ng-model=data.page ng-change=updatePage() items-per-page=data.rows max-size=3 boundary-links=true rotate=false previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo;></pagination></div></div><div class=top-space></div></div>");
  $templateCache.put("partials/contact.html", "<div ng-include=\"\'vlab/cms/contact-page-top\'\"></div><hr><h2 class=space-above>Stay in touch</h2><h3>Sign up to our newsletter</h3><form class=bottom-space action=\"http://designandpost.createsend.com/t/r/s/jrtyijj/\" method=post id=subForm><div><label for=name>Name:</label><br><input type=text name=cm-name id=name><br><label for=jrtyijj-jrtyijj>Email:</label><br><input type=text name=cm-jrtyijj-jrtyijj id=jrtyijj-jrtyijj><br><br><input type=submit value=\"Sign up\"></div></form><div ng-show=newsletters><h3>Previous newsletters</h3><table class=\"table table-striped table-hover\"><thead><tr><th>Newsletter</th><th>Date</th></tr></thead><tbody><tr ng-repeat=\"n in newsletters | filter:isVisible\"><td><a href={{n.WebVersionURL}}>{{n.Subject | truncate:2000}}</a></td><td>{{n.SentDate | localDate}}</td></tr></tbody></table></div>");
  $templateCache.put("partials/data-policy.html", "<h2 class=space-above>HuNI: Data Policy</h2><p>This statement summarizes the policies of the HuNI Virtual Laboratory in relation to its data. It should be read in conjunction with the <a href=#/terms-conditions>HuNI Terms and Conditions of Use</a>.</p><h3>The HuNI Data Aggregate</h3><h4>Data Contained in the HuNI Aggregate</h4><p>The HuNI service contains the following aggregated data:</p><ul><li>Data contributed by data providers. This includes records from source datasets, which have been reformatted to map to the HuNI Data Model;</li><li>User-contributed data. This includes links between HuNI records added by HuNI users, and collections of records assembled and annotated by HuNI users.</li></ul><p>HuNI provides an aggregated view of the data contributed by data providers, but is not intended to be a mechanism for providing users with the actual digital objects (images, texts, videos and the like). That responsibility remains with the data provider. With the agreement of data providers, HuNI may include thumbnails and other abstracted forms where these aid searching and visibility.</p><h4>Data Manager</h4><p>The HuNI service, including the aggregated data, is managed by Deakin University. Deakin University was and is the sub-contractor engaged by the University of Melbourne to manage the development of HuNI under the NeCTAR funding programme.</p><h4>Data Accessibility and Licence under which data is made available</h4><p>The public data in the HuNI service consists of the data contributed by Data Providers, and those user-contributed collections which HuNI users have chosen to make publicly accessible. The public data in the HuNI service is made available under the following <a href=http://www.ausgoal.gov.au/creative-commons-v4.0>AusGOAL / Creative Commons licence</a>:</p><p>Attribution-NonCommercial-ShareAlike 4.0 International (<a href=http://creativecommons.org/licenses/by-nc-sa/4.0/deed.en>CC BY-NC-SA 4.0</a>) This entails that users can copy and redistribute the material in any medium or format and remix, transform, and build upon the material, but only for non-commercial purposes.</p><p>The following terms must be observed:</p><ul><li>Attribution — wherever data from the HuNI Service are re-used, you must give appropriate credit, provide a link to the license, and indicate if changes were made. Further details about attribution are specified in the <em>HuNI Terms and Conditions</em> document.</li><li>NonCommercial – if you remix, transform or build upon the material, this must only be for non-commercial purposes.</li><li>ShareAlike — if you remix, transform, or build upon the material, you must distribute your contributions under the same license as the original.<br></li></ul><h3>Contribution of data: Registered users of HuNI</h3><p>There are three main types of data which may be contributed by registered users of HuNI:</p><ul><li>Links between two HuNI records, added by HuNI users and containing a user\'s assertions about the nature of the link between the two records;</li><li>User Collections, which consist of groups of HuNI records assembled within the HuNI Virtual Laboratory by a registered user for research purposes, and usually annotated by the user who created the collection; and,</li><li>Data collections created using the Heurist software tool developed by the University of Sydney, and contributed to HuNI by individual users.</li></ul><p>User-contributed links are public and attributable to the user who created them. They form part of the publicly accessible \"HuNI Data Aggregate\" and are licenced for re-use on the same basis as the rest of the \"HuNI Data Aggregate\".</p><p>Users who create collections within HuNI may choose to keep a collection private or to share it with a specific named HuNI user or group of users. No public licencing is applicable, but the general \"Terms and Conditions of Use\" apply. The primary purpose of sharing with named user(s) is to facilitate research collaborations, academic debate and the like.</p><p>Users may also choose to publish their collection so that it is viewable as part of the public HuNI service. In this case, the data in the collection are licenced for re-use on the same basis as the rest of the publicly accessible \"HuNI Data Aggregate\".</p><p>The document <em>\"HuNI: Terms and Conditions of Use\"</em> sets out the general terms which govern the use of HuNI, including contribution and re-use of data by individual users.</p><h3>Data Export and Re-use</h3><p>All users of HuNI, whether registered or anonymous, may export and re-use public HuNI data for personal research purposes, in accordance with the general \"Terms and Conditions of Use\" applicable to HuNI.</p><p>Registered individual users of HuNI may additionally export and re-use data which they have contributed to HuNI but not made public, in accordance with the general \"Terms and Conditions of Use\" applicable to HuNI. This permission only covers those private collections created by the user, and does not extend to collections created by another user and shared privately within HuNI.</p><p>HuNI data providers who are interested in exporting enhanced records back from HuNI into their original source dataset may do so under the terms of under the <a href=http://www.ausgoal.gov.au/creative-commons-v4.0>AusGOAL / Creative Commons licence</a>: Attribution-NonCommercial-ShareAlike 4.0 International (<a href=http://creativecommons.org/licenses/by-nc-sa/4.0/deed.en>CC BY-NC-SA 4.0</a>).</p><p>Third-party data aggregators who wish to incorporate HuNI content into their services may do so under the terms of under the <a href=http://www.ausgoal.gov.au/creative-commons-v4.0>AusGOAL / Creative Commons licence</a>: Attribution-NonCommercial-ShareAlike 4.0 International (<a href=http://creativecommons.org/licenses/by-nc-sa/4.0/deed.en>CC BY-NC-SA 4.0</a>).</p><p>Comment or feedback on any aspect of this Data Policy may be made to <a href=mailto:info@huni.net.au>info@huni.net.au</a></p><p>&nbsp;</p>");
  $templateCache.put("partials/glossary.html", "<div ng-include=\"\'vlab/cms/glossary-page\'\"></div>");
  $templateCache.put("partials/governance.html", "<div ng-include=\"\'vlab/cms/governance-page\'\"></div>");
  $templateCache.put("partials/help.html", "<div ng-include=\"\'vlab/cms/help-page\'\"></div>");
  $templateCache.put("partials/history.html", "<div ng-include=\"\'vlab/cms/history-page\'\"></div>");
  $templateCache.put("partials/link.html", "<div class=\"row top-space\"><div class=\"col-lg-12 col-md-12 col-sm-12\"><loading-status status=status loading-message=\"Loading link\" error-message=\"There was an error loading this link\" empty-message=\"This link does not exist\"></loading-status><div ng-show=\"status == \'ok\'\"><h3>{{link.from.displayName}} &#8594; {{link.to.displayName}}</h3><dl><dt>Creator:</dt><dd>{{link.username}}</dd><dt>Updated:</dt><dd>{{link.modified_utc | localDate}}</dd><dt>Created:</dt><dd>{{link.created_utc | localDate}}</dd></dl><table class=\"table table-hover table-striped\" ng-show=\"status == \'ok\'\"><tbody><tr><thead><th>Source record</th><th>Relationship</th><th>Target record</th><th ng-if=user.owns(link)></th></thead></tr><tr><td><record-summary record=link.from></record-summary></td><td style=\"white-space: nowrap\" ng-if=\"link.linktype == link.pairtype\">{{link.linktype}}</td><td style=\"white-space: nowrap\" ng-if=\"link.linktype != link.pairtype\"><span class=\"glyphicon glyphicon-arrow-right\"></span> {{link.linktype}}<br><span class=\"glyphicon glyphicon-arrow-left\"></span> {{link.pairtype}}</td><td><record-summary record=link.to></record-summary></td><td ng-if=user.owns(link) align=right><button type=button class=\"btn btn-primary btn-sm my-collection\" title=\"Manage link\" ng-click=editLink(link)><span class=\"glyphicon icon-manage-link icon-sml\"></span></button></td></tr></tbody></table><h3>Notes</h3><p>{{link.synopsis}}</p></div></div></div>");
  $templateCache.put("partials/links.html", "<div class=span12><h3>Linked Data</h3><p>One of the core pieces of functionality of this site is the ability to assert that two records in the aggregate are indeed linked in some way.</p><p>Whilst browsing search results (assuming you are logged in at this point) you\'ll notice each record has a checkbox labelled <strong>Assert a connection</strong>. Selecting this will tag that item as the <em>source element</em> of a relationship with another record. Upon selection, you\'ll notice that the checkboxes become labelled as <strong>Selct</strong></p></div>");
  $templateCache.put("partials/login.html", "<div class=\"row-fluid top-space\"><div class=\"offset1 span3 pull-left sign-in\"><div class=text-center><h2>Sign in to HuNI</h2></div><div ng-show=providers_visible><div ng-repeat=\"p in providers\"><a ng-href={{p.uri}} ng-click=onLogin()><button class=\"pull-left btn btn-block btn-primary btn-sm login\" type=submit><img ng-src=img/{{p.id}}.png style=\"height: 20px;\"> {{p.name}}</button></a></div></div><div><br><br><div id=spinner></div></div></div><div class=\"span7 pull-left\"><div ng-include=\"\'vlab/cms/login-page\'\"></div></div></div>");
  $templateCache.put("partials/network.html", "<div class=span12><div class=top-space><loading-status status=status></loading-status><record ng-show=\"status==\'ok\'\" record=record snap-in=activeSnapIn logged-in=user.loggedIn user=user></record></div></div>");
  $templateCache.put("partials/partners.html", "<div ng-include=\"\'vlab/cms/partners-page\'\"></div>");
  $templateCache.put("partials/results.html", "<div><div class=\"row top-space\"><div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\"><h2>{{search.title}}</h2><h5>{{search.status}}</h5></div><div class=\"col-lg-7 col-md-7 col-sm-12 col-xs-12\"><pagination ng-show=search.totalRecords ng-disabled=search.isBusy class=pull-left total-items=search.totalRecords ng-model=search.currentPage ng-change=gotoPage(search.currentPage) items-per-page=search.recordsPerPage max-size=3 boundary-links=true rotate=false previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo;></pagination></div><div class=\"col-lg-2 col-md-2 col-sm-3 col-xs-3\"></div></div><div class=\"row top-space\"><div class=\"col-lg-3 col-md-3\"><div ng-if=\"search.hasSourceRecord && search.source\"><div class=\"panel panel-default\" ng-controller=PersistentCollapseController , ng-init=\"init(\'search\', false)\"><div class=panel-heading ng-click=toggleCollapsed()><h4 class=panel-title><a>From Record <span class=\"glyphicon glyphicon-chevron-right\"></span></a></h4></div><record-mini record=search.source collapse=isCollapsed></record-mini></div></div><div ng-if=search.hasUserString><div class=\"panel panel-default\" ng-controller=PersistentCollapseController , ng-init=\"init(\'search\', false)\"><div class=panel-heading ng-click=toggleCollapsed()><h4 class=panel-title><a>Keyword Search <span class=\"glyphicon glyphicon-chevron-right\"></span></a></h4></div><div class=panel collapse=isCollapsed><div class=panel-body><form ng-submit=updateUserString() class=input-group><input type=text class=form-control ng-model=search.userString autofocus> <span class=input-group-btn><button class=\"btn btn-primary\" type=submit ng-disabled=search.isBusy>Search!</button></span></form></div></div></div></div><div class=\"panel panel-default\" ng-controller=PersistentCollapseController ng-init=\"init(\'search-filters\', false)\"><div class=panel-heading ng-click=toggleCollapsed()><h4 class=panel-title><a>Filter All Search Results <span class=\"glyphicon glyphicon-chevron-right\"></span></a></h4></div><div class=panel-collapse><div class=panel collapse=isCollapsed><div ng-repeat=\"facet in search.facet.facets\"><div ng-controller=PersistentCollapseController ng-init=\"init(\'filter-\'+facet.facetName, false)\"><div class=panel-heading><h5>{{facet.displayName}}</h5><a class=\"accordion-toggle show-hide\" ng-click=toggleCollapsed()>show/hide <span class=\"glyphicon glyphicon-play\"></span></a></div><div class=panel-body collapse=isCollapsed><div class=\"checkbox results\" ng-repeat=\"field in facet.fields\"><label><input type=checkbox ng-model=field.isSelected ng-disabled=search.isBusy ng-change=updateFacetSelections(facet.facetName)> {{field.displayName}} <span>({{field.count | number}})</span></label></div></div><hr ng-if=!$last class=side-panel></div></div></div></div></div></div><div class=\"col-lg-9 col-md-9 col-sm-9\"><div ng-include=\"\'vlab/cms/search-results\'\"></div><loading-status status=search.loadingStatus empty-message=\"Your search did not match any records\"></loading-status><record-list records=search.records snap-in=activeSnapIn user=user logged-in=user.loggedIn></record-list><pagination ng-show=search.totalRecords ng-disabled=search.isBusy class=\"pull-left bottom-space\" total-items=search.totalRecords ng-model=search.currentPage ng-change=gotoPage(search.currentPage) items-per-page=search.recordsPerPage max-size=3 boundary-links=true rotate=false previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo;></pagination><div class=return-to-top ng-show=search.records><a ng-click=topOfPage() class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-up\"></span> return to top</a></div></div></div></div><div class=top-space></div>");
  $templateCache.put("partials/search.html", "<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 top-space\"><div id=\'myCarousel\"\' class=\"carousel slide\"><div class=carousel-inner ng-controller=SlideshowController><carousel interval=slideInterval><slide ng-repeat=\"slide in slides\" active=slide.active><img ng-src={{slide.image}} alt=\"HuNI - Human Networked Infrastructure\" width=1215 height=314><div class=carousel-caption><img class=\"img-responsive logo-box\" src=images/huni-logo-carousel.png width=379 height=118 alt=\"HuNI - Human Networked Infrastructure\"><h1>Connect, collect, and contribute to Australian and Canadian cultural records.</h1></div></slide></carousel></div></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\" ng-include=\"\'vlab/cms/front-page-left\'\"></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\" ng-include=\"\'vlab/cms/front-page-right\'\"></div></div><div class=\"clearfix top-space\"></div><hr class=solid-intro><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 browse-category top-space\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 browse-category-lines\"><div class=\"panel-body home-search\" ng-controller=SearchController><h3>Search HuNI</h3><form><div class=\"input-group home-search-bar\"><input type=text class=form-control placeholder=\"Try searching \'Mary Hobbs\', \'Western Desert Art\' or \'Eureka Stockade\'\" ng-model=query autofocus> <span class=input-group-btn><button type=submit ng-click=search() class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-search\"></span></button></span></div></form></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 browse-dots\"><div class=\"panel-body home-search browse-box\"><h3>Browse records by category</h3><div class=\"col-lg-2 col-md-4 col-sm-6 col-xs-12 browse\" ng-repeat=\"cat in [\'Concept\', \'Event\', \'Organisation\', \'Person\', \'Place\', \'Work\']\"><a class={{cat|lowercase}} ng-href=\"#/results?q=*&c={{cat}}\"><div><img ng-src=images/icons/{{cat|lowercase}}.png width=110 height=110 alt=\"icon - {{cat}}\"><br><br>{{cat}}</div></a></div><div class=\"clearfix top-space\"></div></div></div></div></div><div class=\"clearfix top-space\"></div>");
  $templateCache.put("partials/syntax.html", "<div class=span12>This is a brief overview of some of the formatting available with the Markdown language. For more information and more examples see: <a href=https://help.github.com/articles/github-flavored-markdown target=_blank>GitHub Flavoured Markdown.</a><div class=row-fluid><div class=span6><h4>Headings</h4>To style a heading add a preceeding <strong># (hash)</strong>. 1 - 6 of these equate to headings h1 through h6.<br><br>For example:<br># My first heading<br><br>#### My other heading</div><div class=span6><h1>My first heading</h1><h4>My other heading</h4></div></div><hr><div class=row-fluid><div class=span6><h4>Paragraphs</h4>Paragraphs are simply one of more lines of text separated by one or more blank lines.<br><br>For example:<br><br>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec enim urna, laoreet sed velit tristique, porta rhoncus sem. Integer fermentum ut velit vitae consectetur. Nam semper felis id rutrum consequat. Praesent sed convallis libero. Quisque sed cursus nisi.<br><br>Maecenas sed condimentum eros. Donec a laoreet sapien. Aenean facilisis posuere turpis. Vivamus porttitor sem ac felis accumsan tristique. Etiam magna ligula,</div><div class=span6><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec enim urna, laoreet sed velit tristique, porta rhoncus sem. Integer fermentum ut velit vitae consectetur. Nam semper felis id rutrum consequat. Praesent sed convallis libero. Quisque sed cursus nisi.</p><p>Maecenas sed condimentum eros. Donec a laoreet sapien. Aenean facilisis posuere turpis. Vivamus porttitor sem ac felis accumsan tristique. Etiam magna ligula,</p></div></div><hr><div class=row-fluid><div class=span6><h4>Emphasis</h4>To <em>italicize text, surround</em> it with a single asterisk.<br>To make text <strong>bold</strong>, surround it with two asterisks.<br><br>For example:<br>*this will become italicized*<br>**this will be bold**</div><div class=span6><em>this will become italicized</em><br><strong>this will be bold</strong></div></div><hr><div class=row-fluid><div class=span6><h4>Bullet lists, Ordered lists</h4>Bullet lists are created by starting lines with a \"space followed by an asterisk\"<br>Ordered (or numbered) lists are similarly written but using numbers instead of asterisks<br><br>* bullet point 1<br>* bullet point 2<br><br>1. list item 1<br>2. list item 2<br></div><div class=span6><ul><li>bullet point 1</li><li>bullet point 2</li></ul><ol><li>list item 1</li><li>list item 2</li></ol></div></div></div>");
  $templateCache.put("partials/technologies.html", "<div ng-include=\"\'vlab/cms/technologies-page\'\"></div>");
  $templateCache.put("partials/terms-conditions.html", "<h2 class=space-above>HuNI: Terms and Conditions of Use</h2><p>The HuNI service provides aggregated data for the humanities and creative arts in Australia. This material is provided to HuNI by a number of contributing institutions.</p><h3>General Terms and Conditions for Visitors</h3><h4>HuNI Data</h4><p>All data available through HuNI are licenced for reuse under the terms of a Creative Commons Attribution-NonCommercial-ShareAlike 4.0 International (CC BY-NC-SA 4.0) licence. If you re-use data published through HuNI, we ask you to follow the HuNI Usage Guidelines for Data and to provide attribution to the data sources as required by the licence (as stated below).</p><h4>Notice and Takedown</h4><p>If you think that anything included in the HuNI service infringes your rights, you may report this to <a href=mailto:info@huni.net.au>info@huni.net.au</a></p><h4>Liability Disclaimer</h4><p>Deakin University does not guarantee the accuracy or completeness of the HuNI Web site and its content.<br>Except to the extent required by law, Deakin University is not liable for any loss or damage (including any special, consequential, punitive or exemplary damages) suffered by Users contributing to or using the HuNI website or its content. In particular, it will not be liable for:</p><ul><li>the accuracy or completeness of the HuNI website or its content;</li><li>any infringement of copyright in data or content;</li><li>any use of data or content by a user which exceeds the rights granted by these terms and conditions and the licence.</li></ul><h4>These terms of use</h4><p>By exercising any rights to the Web site or its content on grounds of these terms of use, you accept and agree to be bound by these terms of use. Deakin University reserves the right to amend these terms of use.<br>These terms of use are governed by the laws of Australia.</p><h3>Terms and Conditions for User Contributions to HuNI</h3><p>This section contains the terms and conditions applicable to registered Users who contribute content to the HuNI service. By logging into the HuNI service, the User indicates acceptance of these terms and conditions.</p><h4>Registration for the Service</h4><ol><li>Before Content can be contributed, the User must log into to the HuNI service in the manner described on the Web site.</li><li>It is the responsibility of the User to keep their Username/Password combination confidential. The User is therefore responsible for all use that is made of the service through the Username and the Password.</li></ol><h4>Information Relating to Users of HuNI</h4><ol><li>The HuNI service will store the following information about each User: Username/Password, links created by that User, Collections created by or editable by that User, and annotations made by that User to HuNI records. The HuNI service will maintain a log and count of the User\'s activity within HuNI.</li><li>A User\'s association with links between records will be public by default. A User\'s association with collections may or may not be public (at the User\'s discretion). The link count for each User will be public information. No other information about individual Users will be displayed or made available publicly.</li></ol><p>Use of Content by HuNI<ol><li>All Content contributed by a User and made public by that User will be made available to Third Parties by HuNI under the terms of the Creative Commons Attribution-NonCommercial-ShareAlike 4.0 International (CC BY-NC-SA 4.0) licence.</li><li>If the User is not the proprietor of the Intellectual Property Rights of the data contributed by him/her, he/she guarantees that he/she is authorised by the proprietor of the Intellectual Property Rights of the data to contribute the data to HuNI under the terms of the Creative Commons Attribution-NonCommercial-ShareAlike 4.0 International (CC BY-NC-SA 4.0) licence.</li><li>Private collections created by a User within the HuNI service may be shared with other HuNI Users at the discretion of the User who created the collection. The data included in the collection are covered by the general provisions of the HuNI Data Policy. They may be exported and reused by that User under the terms of the Creative Commons Attribution-NonCommercial-ShareAlike 4.0 International (CC BY-NC-SA 4.0) licence.</li></ol></p><h3>HuNI Usage Guidelines for Data</h3><p>All data published in HuNI are available under the AusGOAL Creative Commons licence Attribution-NonCommercial-ShareAlike 4.0 International (CC BY-NC-SA 4.0).</p><h4>Attribution</h4><ul><li>You must give acknowledge the source of the data, provide a link to the CC license, and indicate if you have made any changes to the data.</li><li>You should include attribution to the original data providers as well as to HuNI as the data aggregator. The following wording is recommended: \"the HuNI service managed by Deakin University, and its data providers as listed on the HuNI Web site\".</li><li>You should make sure that others are aware of the rights status of the HuNI data and are aware of these guidelines.</li><li>The attribution may be made either at the level of individual HuNI records or as a general statement.</li><li>You may not suggest that you or your use of the data are endorsed by HuNI, Deakin University or the data providers.</li></ul><h4>Non-Commercial</h4><ul><li>If you remix, transform or build upon the HuNI data, this must only be for non-commercial <a name=_GoBack id=_GoBack></a>purposes.</li></ul><h4>Share Alike</h4><ul><li>If you remix, transform, or build upon the HuNI data, you must distribute your contributions under the same license as the original (i.e., \"Attribution – NonCommercial – Share Alike\").</li></ul><h4>Data are dynamic</h4><ul><li>The data published in HuNI are continually updated. Therefore, the best way to re-use HuNI data is by linking to the specific data rather than by making a static copy available. If, for technical or other reasons, you cannot do this, then include a link back to the source of the data in HuNI or implement an update mechanism.</li></ul><p>Please note that you use the data at your own risk</p><ul><li>HuNI offers the data \"as-is\" and makes no representations or warranties of any kind concerning any data published in HuNI.</li><li>Any use of the data must conform to all applicable laws and other regulations in your jurisdiction, notably concerning (but not limited to) data protection, defamation or copyright.</li><li>Be aware of any additional applicable community norms of data providers and data aggregators.</li></ul><p>&nbsp;</p>");
  $templateCache.put("partials/user.html", "<div class=\"col-lg-12 col-md-12 col-sm-12 user-profile\"><h2>User Profile: {{ user.name }}</h2><div ng-if=own_profile><div ng-show=user.show_profile_info>This is your public profile. You can update this information in <a href=#/myhuni/profile>your profile settings</a>.</div><div ng-hide=user.show_profile_info>This is your full private profile, other users can only see your name. You can make this information public in <a href=#/myhuni/profile>your profile settings</a>.</div></div><div ng-if=\"!own_profile && !user.show_profile_info\">{{ user.name }} has opted to keep their profile private.</div><table ng-if=\"own_profile || user.show_profile_info\" class=user-profile><tr><th scope=row>Email</th><td ng-show=\"user.email | isNonEmpty\"><a href=\"mailto:{{ user.email }}\">{{ user.email }}</a></td><td ng-hide=\"user.email | isNonEmpty\">-</td><td></td></tr><tr><th scope=row>Institutions</th><td ng-show=\"user.institutions | isNonEmpty\">{{ user.institutions }}</td><td ng-hide=\"user.institutions | isNonEmpty\">-</td><td></td></tr><tr><th scope=row>Description</th><td ng-show=\"user.description | isNonEmpty\">{{ user.description }}</td><td ng-hide=\"user.description | isNonEmpty\">-</td><td></td></tr><tr><th scope=row>Interests</th><td ng-show=\"user.interests | isNonEmpty\">{{ user.interests }}</td><td ng-hide=\"user.interests | isNonEmpty\">-</td><td></td></tr><tr><th scope=row>Collaboration Interests</th><td ng-show=\"user.collaboration_interests | isNonEmpty\">{{ user.collaboration_interests }}</td><td ng-hide=\"user.collaboration_interests | isNonEmpty\">-</td><td></td></tr></table></div>");
  $templateCache.put("partials/workflow-tool.html", "<h3>workflow tool</h3><p>text</p>");
  $templateCache.put("partials/buttons/collection.html", "<button class=\"btn btn-sm {{mode == \'remove\' ? \'btn-danger\' : \'btn-primary\'}}\" title=\"{{mode == \'remove\' ? \'Remove from collection\' : \'Add to collection\' }}\" ng-disabled=isDisabled ng-click=click()><span ng-switch=mode><span ng-switch-when=add class=\"glyphicon icon-add-record icon-sml\"></span> <span ng-switch-when=remove class=\"glyphicon icon-rem-record icon-sml\"></span> <span ng-switch-default class=\"glyphicon icon-add-collect icon-sml\"></span></span></button>");
  $templateCache.put("partials/buttons/embed.html", "<button class=\"btn btn-primary btn-sm\" type=button title=\"Get Network Embed\" ng-disabled=!isEnabled ng-click=\"$emit(\'EmbedEvent\', record)\"><span class=\"glyphicon icon-embed icon-sml\"></span></button>");
  $templateCache.put("partials/buttons/export-collection.html", "<button type=button class=\"btn btn-info btn-sm\" ng-click=exportCollection() analytics-on analytics-event=export analytics-category=collection analytics-label={{baseUri}}/{{c.id}} title=\"Export Collection to CSV\"><span class=\"glyphicon icon-export-collect icon-sml\"></span></button><form name=\"{{ formName }}\" accept-charset=UTF-8 method=post action=/vlab/export xxenctype=multipart/form-data><input type=hidden name=data value={{exportData}}></form>");
  $templateCache.put("partials/buttons/graph-view.html", "<button class=\"btn btn-primary btn-sm\" type=button title=\"Graph View\" ng-click=click()><span class=\"glyphicon icon-graph-view icon-sml\"></span></button>");
  $templateCache.put("partials/buttons/link.html", "<button class=\"btn {{canComplete ? \'btn-success btn-highlight btn-sm\' : \'btn-primary btn-sm\'}}\" title=\"{{canComplete ? \'Link to this\' : \'Create a new link\'}}\" ng-disabled=!isEnabled ng-click=\"$emit(\'AddRecordToLinkEvent\', record)\"><span class=\"glyphicon {{canComplete ? \'icon-add-link\' : \'icon-new-link\'}} icon-sml\"></span></button>");
  $templateCache.put("partials/buttons/login.html", "<a class=\"btn btn-primary navbar-btn btn-sm\" ng-disabled=!user.vlabUp ng-click=click()><span class=\"glyphicon glyphicon-user\"></span> <span class=\"hidden-sm hidden-xs\" ng-show=user.loggedIn>Log out {{user.name}}</span> <span class=\"hidden-md hidden-lg\" ng-show=user.loggedIn>Log out</span> <span ng-hide=user.loggedIn>Log in</span></a>");
  $templateCache.put("partials/buttons/query.html", "<button class=\"btn {{canComplete ? \'btn-success btn-highlight btn-sm\' : \'btn-primary btn-sm\'}}\" title=\"{{canComplete ? \'Find links from this\' : \'Find links to this\'}}\" ng-disabled=!isEnabled ng-click=\"$emit(\'AddRecordToQueryEvent\', record)\"><span class=\"glyphicon {{canComplete ? \'icon-query-end\' : \'icon-query-start\'}} icon-sml\"></span></button>");
  $templateCache.put("partials/dialogs/choose-collection.html", "<div class=modal-header><h3 class=modal-title>Select a collection</h3></div><div class=modal-body><div ng-if=loading>Loading your collections</div><div ng-if=\"!loading && error\">{{error}}</div><tabset ng-if=\"!loading && !error\"><tab heading=\"Choose an existing collection\" active=tab.choose_existing.active disable=tab.choose_existing.disabled><select ng-model=data.selectedCollection ng-options=\"c.name for c in collections\" class=form-control></select></tab><tab heading=\"&#65291; Create a new collection\" active=tab.create_new.active disable=tab.create_new.disabled><input ng-model=data.newCollection type=text class=form-control placeholder=\"Name your collection\"></tab></tabset></div><div class=modal-footer><button class=\"btn btn-success\" ng-disabled=\"loading||error||(tab.create_new.active && data.newCollection.trim().length == 0)\" ng-click=ok()>OK</button> <button class=\"btn btn-warning\" ng-click=\"$dismiss(\'Cancelled\')\">Cancel</button></div>");
  $templateCache.put("partials/dialogs/collection-details.html", "<div class=modal-header><h3 class=modal-title>{{ title }}</h3></div><div class=modal-body><div ng-show=permissions.can_edit_title><label for=name>Name</label> <input type=text class=form-control id=name ng-model=name></div><div ng-show=permissions.can_edit_notes><label for=synopsis>Notes</label> <textarea placeholder=\"Notes for collection\" class=form-control rows=4 id=synopsis ng-model=synopsis></textarea></div></div><div class=modal-footer><button class=\"btn btn-success\" ng-disabled=!name ng-click=close()>OK</button> <button class=\"btn btn-warning\" ng-click=\"$dismiss(\'Cancelled\')\">Cancel</button></div>");
  $templateCache.put("partials/dialogs/confirmation.html", "<div class=modal-header><h3 class=modal-title ng-bind-html=\"message | trust\"></h3></div><div class=modal-footer><button class=\"btn btn-success\" ng-click=$close(true)>Yes</button> <button class=\"btn btn-warning\" ng-click=\"$dismiss(\'Cancelled\')\">No</button></div>");
  $templateCache.put("partials/dialogs/create-linktype.html", "<form name=dialog novalidate><div class=modal-header><h3 class=modal-title>Create a new relationship type</h3></div><div class=modal-body><div>{{fromRecord | recordName}} <input type=text placeholder=\"e.g. Sample relationship\" ng-model=data.name ng-required=true typeahead=\"s for s in names | matchLookahead:$viewValue | limitTo:16\"> {{toRecord | recordName}}</div><hr><input type=checkbox ng-model=data.symmetric> <em>This relationship is the same in both directions</em><hr><div class=target>{{toRecord | recordName}} <input type=text ng-model=data.pair ng-required=!data.symmetric ng-hide=data.symmetric placeholder=\"e.g. Sample relationship\" typeahead=\"s for s in names | matchLookahead:$viewValue | limitTo:16\"> <input type=text ng-model=data.name ng-show=data.symmetric ng-disabled=true placeholder=\"e.g. Sample relationship\" typeahead=\"s for s in names | matchLookahead:$viewValue | limitTo:16\"> {{fromRecord | recordName}}</div></div><div class=modal-footer><button class=\"btn btn-success\" ng-click=ok() ng-disabled=!dialog.$valid>OK</button> <button class=\"btn btn-warning\" ng-click=\"$dismiss(\'Cancelled\')\">Cancel</button></div></form>");
  $templateCache.put("partials/dialogs/licence.html", "<div class=modal-header><h3 class=modal-title>Licence</h3></div><div class=modal-body>HuNI data are made available under the following <a href=http://www.ausgoal.gov.au/creative-commons-v4.0>AusGOAL / Creative Commons licence</a>: Attribution-NonCommercial-ShareAlike 4.0 International (<a href=http://creativecommons.org/licenses/by-nc-sa/4.0/deed.en>CC BY-NC-SA 4.0</a>)</div><div class=modal-footer><button class=\"btn btn-success\" ng-click=$close(true)>Acknowledge</button></div>");
  $templateCache.put("partials/dialogs/link-note.html", "<div class=modal-header><h3 class=modal-title>Notes for link</h3></div><div class=modal-body><textarea placeholder=\"Notes for link\" class=form-control rows=4 ng-model=linknote></textarea></div><div class=modal-footer><button class=\"btn btn-success\" ng-click=$close(linknote)>OK</button> <button class=\"btn btn-warning\" ng-click=\"$dismiss(\'Cancelled\')\">Cancel</button></div>");
  $templateCache.put("partials/dialogs/link-view.html", "<div class=modal-header><h3 class=modal-title>{{message}} {{link.from.displayName}} &#8594; {{link.to.displayName}}</h3></div><div class=modal-body><dl><dt>Creator:</dt><dd>{{link.user.name}}</dd><dt>Updated:</dt><dd>{{link.modified_utc | localDate}}</dd><dt>Created:</dt><dd>{{link.created_utc | localDate}}</dd></dl><table class=\"table table-hover table-striped\"><tbody><tr><thead><th>Source record</th><th>Relationship</th><th>Target record</th><th ng-if=user.owns(link)></th></thead></tr><tr><td><record-summary record=link.from></record-summary></td><td style=\"white-space: nowrap\" ng-if=\"link.linktype == link.pairtype\">{{link.linktype}}</td><td style=\"white-space: nowrap\" ng-if=\"link.linktype != link.pairtype\"><span class=\"glyphicon glyphicon-arrow-right\"></span> {{link.linktype}}<br><span class=\"glyphicon glyphicon-arrow-left\"></span> {{link.pairtype}}</td><td><record-summary record=link.to></record-summary></td><td ng-if=user.owns(link) align=right><button type=button class=\"btn btn-primary btn-sm my-collection\" title=\"Manage link\" ng-click=editLink(link)><span class=\"glyphicon icon-manage-link icon-sml\"></span></button></td></tr></tbody></table><h3>Notes</h3><p>{{link.synopsis}}</p></div><div class=modal-footer><button class=\"btn btn-success\" ng-click=$close(true)>Close</button></div>");
  $templateCache.put("partials/directives/collection-list.html", "<table class=\"table table-striped table-hover\" ng-show=collections.length><thead><tr><th>Collection name</th><th>Size</th><th>Last modified</th><th ng-if=public><span class=\"glyphicon glyphicon-user\"></span> Who made this collection?</th><th ng-if=!public>Role</th><th ng-if=!public>Public</th><th class=right>Actions</th></tr></thead><tbody><tr ng-repeat=\"c in collections | filter:isVisible\"><td><a href={{baseUri}}/{{c.id}}><span class=\"icon-sml icon-collection\"></span> {{c.name | truncate:60}}</a></td><td><record-count count={{c.record_count}}></record-count></td><td>{{c.modified_utc | localDate}}</td><td ng-if=public><user-list-short users=c.owners link={{baseUri}}/{{c.id}}></user-list-short>{{c.username}}</td><td ng-if=!public><select ng-model=c.role_id ng-disabled=!canChangeRole(c) class=form-control ng-change=\"onRoleChange(c, \'{{ c.role_id }}\')\"><option ng-repeat=\"role in roleOptions\" value=\"{{ role.id }}\">{{ role.name }}</option><option value=remove>Remove Me</option></select></td><td ng-if=!public><span ng-show=c.is_public class=\"glyphicon glyphicon-eye-open\" title=Public></span> <span ng-hide=c.is_public class=\"glyphicon glyphicon-minus\" title=Private></span></td><td><graph-view-button docid=c.docid></graph-view-button><button ng-if=!public type=button class=\"btn btn-primary btn-sm\" ng-disabled=!permissions(c).can_add_records ng-click=activateCollection(c) title=\"Manage Collection\"><span class=\"glyphicon icon-manage-collect icon-sml\"></span></button> <button ng-if=!public type=button class=\"btn btn-danger btn-sm\" ng-disabled=!permissions(c).can_delete title=\"Delete Collection\" ng-click=deleteCollection(c)><span class=\"glyphicon icon-delete-collect icon-sml\"></span></button> <button ng-if=!public type=button class=\"btn btn-info btn-sm\" ng-disabled=!permissions(c).can_manage_users ng-click=manageCollectionUsers(c) title=\"Manage Users\"><span class=\"glyphicon icon-user icon-sml\"></span></button><export-collection-button collection=c></export-collection-button></td></tr></tbody></table>");
  $templateCache.put("partials/directives/huni-alert.html", "<div class=\"alert alert-dismissable alert-{{type}}\" role=alert><button type=button class=close ng-click=close()><span aria-hidden=true>&times;</span> <span class=sr-only>Close</span></button><div ng-transclude></div></div>");
  $templateCache.put("partials/directives/loading-status.html", "<span ng-switch=status><div ng-switch-when=empty class=\"huni-status huni-status-empty\"><h3>{{emptyMessage }}</h3></div><div ng-switch-when=error class=\"huni-status huni-status-error\"><h3>{{errorMessage }}</h3><img src=images/bees/crashing.png></div><div ng-switch-when=loading class=\"huni-status huni-status-loading\"><h3>{{loadingMessage }}</h3></div></span>");
  $templateCache.put("partials/directives/myhuni-pills.html", "<div class=\"col-lg-4 col-md-4\"><ul class=\"pagination pagination-lg\"><li ng-repeat=\"i in items\" ng-class=isActive(i.page)><a href=#/myhuni/{{i.page}}>{{i.text}}</a></li></ul></div><div class=\"col-lg-8 col-md-8\"><huni-alert class=myhuni-alert type=userAlert.type close=closeAlert() ng-if=displayMessage>{{displayMessage}}</huni-alert></div>");
  $templateCache.put("partials/directives/record-count.html", "<ng-pluralize count=count when=\"{\'0\': \'No records\', \'1\': \'1 record\', \'other\': \'{} records\'}\"></ng-pluralize>");
  $templateCache.put("partials/directives/record-list.html", "<span ng-repeat=\"r in records\"><record record=r snap-in=snapIn brief=true user=user></record></span>");
  $templateCache.put("partials/directives/record-mini.html", "<div class=\"panel panel-default {{record | recordClass}}\"><div class=panel-body><a class=\"{{record | recordClass}}\" title=\"View Full Record\" ng-href=#/record/{{record.docid}}><span class=\"icon-sml icon-{{record | recordClass}}\"></span> {{record | recordClass | uppercase}}: {{record | recordName}}</a></div></div>");
  $templateCache.put("partials/directives/record-summary.html", "<a href=#/record/{{record.docid}}><span class=\"{{record | recordClass}}\"><span class=\"icon-sml icon-{{record | recordClass}}\"></span> {{ record | recordName | truncate:32 }}</span></a>");
  $templateCache.put("partials/directives/record.html", "<div class=\"panel panel-default {{record | recordClass}}\" ng-style=\"embedded ? {\'height\': \'calc(100vh - 52px)\', \'margin-bottom\': 0} : {}\"><div class=panel-body id=panel-body><div class=\"checkbox right\"><span ng-if=\"brief && !embedded\"><graph-view-button docid=record.docid></graph-view-button></span> <span ng-if=\"!brief && !embedded\"><embed-button record=record snap-in=snapIn></embed-button></span> <span ng-if=\"user.loggedIn && !isCollection() && !embedded\"><collection-button record=record snap-in=snapIn></collection-button></span> <span ng-if=\"user.loggedIn && !isCollection() && !embedded\"><link-button record=record snap-in=snapIn></link-button></span> <span ng-if=\"record.linkCount && !embedded\"><query-button record=record snap-in=snapIn></query-button></span> <span ng-if=\"isCollection() && !embedded\"><export-collection-button collection=record></export-collection-button></span></div><h5 ng-if=\"brief && !embedded\"><a class=\"{{record | recordClass}}\" title=\"View Full Record\" ng-href=#/record/{{record.docid}}><span class=\"icon-sml icon-{{record | recordClass}}\"></span> {{record | recordClass | uppercase}}: {{record | recordName}}</a></h5><h5 class=detail-view ng-if=\"!brief && !embedded\"><span class=\"icon-sml icon-{{record | recordClass}}\"></span> {{record | recordClass | uppercase}}: {{record | recordName}}</h5><h5 ng-if=\"!brief && embedded\"><a class=\"{{record | recordClass}} a-embed\" title=\"View Full Record\" ng-href=/#/record/{{record.docid}} target=_blank><span class=\"icon-sml icon-{{record | recordClass}}\"></span> {{record | recordClass | uppercase}}: {{record | recordName}}</a></h5><div ng-if=!brief id=graph ng-style=\"embedded ? {\'height\': \'calc(100vh - 162px)\'} : {}\"></div><h5 class=detail-view ng-if=\"!brief && !embedded\"><span class=\"icon-sml icon-{{record | recordClass}}\"></span> {{record | recordClass | uppercase}}: {{record | recordName}}</h5><h3 ng-if=\"!brief && !embedded\">Details</h3><p ng-if=\"record.sourceRecordLink && record.sourceSiteAddress && !isCollection() && !embedded\"><strong>View</strong> <a ng-href={{record.sourceRecordLink}}>original record</a> from <a href={{record.sourceSiteAddress}}>{{record.sourceAgencyName}}</a></p><p ng-if=\"record.sourceRecordLink && !record.sourceSiteAddress && !isCollection() && !embedded\"><strong>View</strong> <a ng-href={{record.sourceRecordLink}}>original record</a> from {{record.sourceAgencyName}}</p><p ng-if=\"!record.sourceRecordLink && !isCollection() && !embedded\"><strong>Provider:</strong> <span ng-if=record.sourceRecordLink><a ng-href={{record.sourceRecordLink}}>{{record.sourceAgencyName}}</a></span> <span ng-if=!record.sourceRecordLink>{{record.sourceAgencyName}}</span></p><p ng-show=\"record.warning | isNonEmpty\" ng-if=!embedded><span ng-bind-html=\"record.warning | trust\"></span></p><p ng-show=\"record.type | isNonEmpty\" ng-if=!embedded><strong>Type:</strong> {{record.type}}</p><p ng-show=\"record.startDate || record.endDate\" ng-if=!embedded><span ng-show=\"record.startDate && !record.birthDate && !record.creationDate\"><strong>Started:</strong> {{record.startDate}}</span> <span ng-show=record.birthDate><strong>Birth:</strong> {{record.birthDate}}</span> <span ng-show=record.creationDate><strong>Created:</strong> {{record.creationDate}}</span> <span ng-show=\"record.endDate && !record.deathDate\"><strong>Ended:</strong> {{record.endDate}}</span> <span ng-show=record.deathDate><strong>Death:</strong> {{record.deathDate}}</span> <span ng-show=record.releaseDate><strong>Released:</strong> {{record.releaseDate}}</span></p><p ng-show=\"record.function | isNonEmpty\" ng-if=!embedded><strong>Function:</strong> <span>{{record.function}}</span></p><p ng-show=\"record.occupation | isNonEmpty\" ng-if=!embedded><strong>Occupation:</strong> {{record.occupation}}</p><p ng-show=\"record.biography | isNonEmpty\" ng-if=!embedded><strong>Biography:</strong> {{record.biography | truncate:200:!brief}}</p><p ng-show=\"record.format | isNonEmpty\" ng-if=!embedded><strong>Format:</strong> {{record.format}}</p><p ng-show=\"record.formatDetails | isNonEmpty\" ng-if=!embedded><strong>Format Details:</strong> {{record.formatDetails}}</p><p ng-show=\"record.publishedIn | isNonEmpty\" ng-if=!embedded><strong>Published In:</strong> {{record.publishedIn}}</p><p ng-show=\"record.mentions.length > 0\" ng-if=!embedded><strong>Mentions:</strong></p><p class=mention ng-repeat=\"m in record.mentions.slice(0, mentionsToShow(record))\"><span ng-bind-html=\"mentionLink(m) | trust\"></span></p><p class=mention ng-if=\"mentionsToShow(record) < record.mentions.length\"><a title=\"View Full Record\" ng-href=#/record/{{record.docid}}>(and {{record.mentions.length - mentionsToShow(record)}} more)</a></p><p></p><p ng-show=\"record.description | isNonEmpty\" ng-if=!embedded><strong>Description:</strong> {{record.description | truncate:200:!brief}}</p><p ng-show=\"record.url | isNonEmpty\" ng-if=!embedded><strong>Web Link:</strong> <a href=\"{{record.url | weblink}}\">{{record.url | weblink}}</a></p><p ng-show=\"record.language | isNonEmpty\" ng-if=!embedded><strong>Language:</strong> {{record.language}}</p><p ng-if=\"brief && !isCollection() && !embedded\"><span class=\"icon-tiny icon-collection-stack\"></span> <strong><span title=\"This record appears in the following user-created collections\">Collections:</span></strong> <span ng-repeat=\"c in sortedCollections(record)\"><a href={{collectionUri(c)}}>{{c.name}}</a><span ng-if=!$last>,</span></span> <span ng-if=!hasCollections(record)>None</span></p><p ng-show=\"brief && !isCollection()\" ng-if=!embedded><span class=\"glyphicon glyphicon-link\"></span>&nbsp; <strong><span title=\"This record has been linked to other records by HuNI users\">Record Links:</span></strong> {{record.linkCount}}</p><p ng-show=\"brief && !isCollection() && record.baconDistance\" ng-if=!embedded><strong><span title=\"Distance to Kevin Bacon\">Bacon Distance:</span></strong> {{record.baconDistance}} <a ng-href=#/record/{{record.docid}}/{{record.bacon_docid}}><span class=\"glyphicon glyphicon-circle-arrow-right\"></span> View path</a></p><p ng-if=\"brief && isCollection() && record.record_count && !embedded\"><span class=\"icon-tiny icon-collection-stack\"></span> <strong><span title=\"This user-created collection contains the following number of HuNI records\">Record count:</span></strong> <span>{{record.record_count}}</span></p><p ng-show=\"!brief && record.username\" ng-if=!embedded><strong>Created by:</strong> {{record.username}}</p><p ng-show=brief ng-if=!embedded><a ng-href=#/record/{{record.docid}}><span class=\"glyphicon glyphicon-circle-arrow-right\"></span> View Full Record</a></p><hr ng-if=\"!brief && !isCollection() && !embedded\" class=solid-space><div ng-if=\"!brief && !isCollection() && !embedded\"><h3>Collections</h3><p ng-hide=hasCollections(record)><em>{{record | recordName}} has not yet been included in any collections.</em></p><p ng-show=hasCollections(record)>{{record | recordName}} is contained in the following collections:</p><table class=\"table table-striped table-hover\" ng-if=hasCollections(record)><thead><tr><th>Collection name</th><th>Record count</th><th><span class=\"glyphicon glyphicon-user\"></span> Who owns this collection?</th><th></th></tr></thead><tbody><tr ng-repeat=\"c in sortedCollections(record)\" ng-mouseenter=\"highlightLink(c, true)\" ng-mouseleave=\"highlightLink(c, false)\" xxx-ng-click=selectLink(c.docid)><td><record-summary record=c></record-summary></td><td><record-count count={{c.record_count}}></record-count></td><td><user-list-short users=c.owners link=\"{{ collectionUri(c) }}\"></user-list-short></td><td style=\"text-align: right;\"><a href={{c.link}}>view</a></td></tr></tbody></table></div><hr ng-if=\"!brief && !embedded\" class=solid-space><div ng-if=\"!brief && !embedded\"><h3>Links</h3><p ng-hide=hasLinks(record)><em>{{record | recordName}} has not yet been linked to other records.</em></p><p ng-show=hasLinks(record)>{{record | recordName}} is linked to the following:</p><table class=\"table table-striped table-hover\" ng-if=hasLinks(record)><thead><tr><th>Record name</th><th><span class=\"glyphicon glyphicon-arrow-right\"></span> Relationship <em>to</em> selected</th><th><span class=\"glyphicon glyphicon-arrow-left\"></span> Relationship <em>from</em> selected</th><th><span class=\"glyphicon glyphicon-user\"></span> Who made this link?</th><th ng-if=!isCollection()></th></tr></thead><tbody><tr ng-repeat=\"link in record.links\" ng-mouseenter=\"highlightLink(link, true)\" ng-mouseleave=\"highlightLink(link, false)\" xxx-ng-click=selectLink(link.to_docid)><td><record-summary record=link.record></record-summary></td><td>{{link.linktype}}</td><td>{{link.pairtype}}</td><td><user user=link.user></user></td><td ng-if=!isCollection() style=\"text-align: right;\"><a ng-click=viewLink(link)>view</a></td></tr></tbody></table></div></div></div><div ng-if=embedded id=embed-text><p ng-if=\"record.sourceRecordLink && record.sourceSiteAddress && !isCollection()\" class=embed-text>Embedded <a href=https://huni.net.au target=_blank>HuNI</a> view of <a ng-href={{record.sourceRecordLink}} target=_blank>original record</a> from <a href={{record.sourceSiteAddress}} target=_blank>{{record.sourceAgencyName}}</a></p><p ng-if=\"record.sourceRecordLink && !record.sourceSiteAddress && !isCollection()\" class=embed-text>Embedded <a href=https://huni.net.au target=_blank>HuNI</a> view of <a ng-href={{record.sourceRecordLink}} target=_blank>original record</a> from {{record.sourceAgencyName}}</p></div>");
  $templateCache.put("partials/directives/user-list-short.html", "<a ng-href=\"{{ link }}\" title=\"{{ title() }}\">{{ text() }}</a>");
  $templateCache.put("partials/directives/user-list.html", "<span ng-if=users.length ng-repeat=\"user in users\"><user user=user></user>{{ $last ? \'\' : ($index==users.length-2) ? \' and \' : \', \' }}</span> <span ng-if=!users.length>Nobody</span>");
  $templateCache.put("partials/directives/user.html", "<a ng-href=#/user/{{user.id}}>{{ user.name }}</a>");
  $templateCache.put("partials/snapins/collection.html", "<form name=form novalidate><div id=collection-snapin class=workflow-bar-fixed ng-if=isActive><div class=close-window><button type=button class=\"btn btn-info btn-sm\" ng-click=close()><span class=\"glyphicon glyphicon-remove\"></span> Close</button></div><h3>Manage <a href=#/myhuni/collection/{{selectedCollection.id}}>{{selectedCollection.name}}</a> <span class=record-number>(<record-count count={{selectedCollection.record_count}}></record-count>)</span> <button ng-show=permissions().can_edit_title type=button class=\"btn btn-primary btn-sm\" ng-click=editDetails()><span class=\"glyphicon glyphicon-pencil\"></span> Edit</button></h3><div ng-if=message><alert type=success close=closeAlert() ng-show=ok>{{message}} <a ng-click=undoCollectionOperation()>UNDO <span class=\"glyphicon glyphicon-repeat\"></span></a></alert><alert type=danger close=closeAlert() ng-hide=ok>{{message}} <a ng-if=undo ng-click=undoCollectionOperation()>Try Again? <span class=\"glyphicon glyphicon-repeat\"></span></a></alert></div><div class=notes><h5 class=inline>Collection notes:</h5>{{selectedCollection.synopsis | truncate:40}} <button ng-show=permissions().can_edit_notes type=button class=\"btn btn-primary btn-sm\" ng-click=editDetails()><span class=\"glyphicon glyphicon-pencil\"></span> Edit</button></div><div class=collection-actions ng-show=permissions().can_publish><h5 class=inline>Make collection public:</h5><div class=\"btn-group btn-toggle privacy\"><input class=form-control type=checkbox ng-model=selectedCollection.is_public ng-change=updateIsPublic($value)></div></div></div></form>");
  $templateCache.put("partials/snapins/embed.html", "<form name=form novalidate><div id=embed-snapin class=workflow-bar-fixed ng-if=isActive><div class=close-window><button type=button class=\"btn btn-info btn-sm\" ng-click=copyToClipboard()><span class=\"glyphicon glyphicon-copy\"></span> Copy</button> <button type=button class=\"btn btn-info btn-sm\" ng-click=close()><span class=\"glyphicon glyphicon-remove\"></span> Close</button></div><h3>Embed Code</h3><pre id=embed-code ng-bind=embedCode()>\n  </pre></div></form>");
  $templateCache.put("partials/snapins/link.html", "<form name=form novalidate><div id=link-snapin class=workflow-bar-fixed ng-if=isActive><div class=close-window><button ng-if=form.$pristine type=button class=\"btn btn-info btn-sm\" ng-click=close()><span class=\"glyphicon glyphicon-remove\"></span> Close</button> <button ng-if=form.$dirty type=button class=\"btn btn-danger btn-sm\" ng-click=close(true)><span class=\"glyphicon glyphicon-remove\"></span> Cancel</button></div><h3 ng-if=!link>Create a new link</h3><h3 ng-if=link>Manage your link</h3><alert type=success ng-show=showAlert close=closeAlert()><span ng-bind-html=\"getAlertMessage() | trust\"></span></alert><div class=input-group><div class=source-box>{{fromRecord | recordName | truncate:40}}<select class=\"form-control {{toRecord && !rw.selectedLHS && \'sel-highlight\'}}\" ng-model=rw.selectedLHS ng-change=lhsChanged() ng-disabled=!toRecord ng-options=\"lt.name for lt in linktypes\"><option>-- select a relationship --</option></select><span class=\"glyphicon glyphicon-arrow-right\"></span> <strong ng-hide=toRecord><span class=\"glyphicon icon-add-link icon-sml\"></span> Select record below</strong><span class=sel-record>{{toRecord | recordName | truncate:40}}</span></div><div class=clearfix></div><div class=target-box>{{toRecord | recordName | truncate:40}} <strong ng-hide=toRecord><span class=\"glyphicon icon-add-link icon-sml\"></span> Select record below</strong> <span class=\"glyphicon glyphicon-arrow-right\"></span><select class=\"form-control {{rw.selectedLHS && !rw.selectedRHS && \'sel-highlight\'}}\" ng-model=rw.selectedRHS ng-change=rhsChanged() ng-disabled=!rw.selectedLHS ng-options=\"lt.pair for lt in rw.selectedLHS.pairs\"><option>-- select a relationship --</option></select>{{fromRecord | recordName | truncate:40}}</div><div class=save-box><button ng-type=button name=saveButton class=\"btn {{(!rw.selectedRHS || form.$pristine) ? \'btn-primary\' : \'btn-success btn-highlight\'}}\" ng-click=saveLink() ng-disabled=\"!rw.selectedRHS || form.$pristine\">Save link</button></div></div><div class=notes><h5 class=inline>Link notes:</h5>{{rw.linknote | truncate:40}} <button type=button class=\"btn btn-primary btn-sm\" ng-click=editNote()><span class=\"glyphicon glyphicon-file\"></span> <span ng-if=rw.linknote>Edit note</span> <span ng-if=!rw.linknote>Add note</span></button></div></div></form>");
  $templateCache.put("partials/snapins/query.html", "<form name=form novalidate><div id=link-snapin class=workflow-bar-fixed ng-if=isActive><div class=close-window><button type=button class=\"btn btn-info btn-sm\" ng-click=close()><span class=\"glyphicon glyphicon-remove\"></span> Close</button></div><h3>Graph query</h3><alert type=success ng-show=showAlert close=closeAlert()><span ng-bind-html=\"getAlertMessage() | trust\"></span></alert><div class=input-group><div>Click <button ng-type=button class=\"btn btn-success btn-highlight\" ng-click=findReachableNodes()><span class=\"glyphicon icon-query-start\"></span> Find reachable nodes</button> to find all records reachable from &nbsp;<record-summary record=fromRecord></record-summary></div><div>Or, choose another record below and click <span class=\"glyphicon icon-query-end\"></span> to find the shortest path between these nodes, if one exists.</div></div></div></form>");
  $templateCache.put("partials/myhuni/collection-users.html", "<div class=row ng-if=!isPublic><my-huni-pills active-tab=collections user-alert=userAlert></my-huni-pills></div><hr><div class=\"col-lg-12 col-md-12 col-sm-12 single-collection\"><loading-status status=status empty-message=\"Collection not found\"></loading-status><h2 ng-show=\"status == \'ok\'\">Collection Users: {{ collection.name }}</h2><div class=\"panel panel-default collection-users col-lg-12 col-md-12 col-sm-12\" ng-show=\"status == \'ok\'\"><div class=\"panel-body col-lg-8 col-md-8 col-sm-12\"><div class=row><label ng-show=\"!users || users.length == 0\">You\'re the only user. You can add other users here.</label> <label ng-show=\"users.length > 0\">Find more users to add.</label> <input type=text ng-model=newUser.user placeholder=\"Type parts of the user\'s name\" typeahead=\"user as user.name for user in userTypeahead($viewValue)\" typeahead-editable=false typeahead-loading=loadingUsers class=form-control></div></div><div class=\"panel-body col-lg-2 col-md-2 col-sm-12\"><div class=row><label>Select role</label><select class=form-control ng-model=newUser.role_id><option ng-repeat=\"role in roleOptions\" value=\"{{ role.id }}\">{{ role.name }}</option></select></div></div><div class=\"panel-body col-lg-2 col-md-2 col-sm-12\"><div class=row><label>Add user</label> <button class=\"btn btn-info form-control\" type=button ng-click=addUser() ng-disabled=!newUser.user>Add User</button></div></div></div><table class=\"table collection-users\" ng-show=\"users.length > 0\"><tr><th>User</th><th>Role</th><th>Added By</th><th>Remove</th></tr><tr ng-repeat=\"user in users | orderBy:\'user.name\'\"><td><user user=user.user></user></td><td><select class=form-control ng-model=user.role_id ng-disabled=!canModify(user) ng-change=updateRole(user)><option ng-repeat=\"role in roleOptions\" value=\"{{ role.id }}\">{{ role.name }}</option></select></td><td><user user=user.inviting_user></user></td><td><button type=button class=\"btn btn-warning btn-sm\" ng-disabled=!canModify(user) ng-click=removeUser(user)>Remove User</button></td></tr></table></div>");
  $templateCache.put("partials/myhuni/collections.html", "<div class=row><my-huni-pills active-tab=collections user-alert=userAlert></my-huni-pills></div><hr><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12\"><loading-status status=status empty-message=\"You don\'t have any collections\" error-message=\"There was an error loading your collections\" loading-message=\"Loading your collections\"></loading-status><collection-list base-uri=#/myhuni/collection collections=collections is-public=false user-alert=userAlert></collection-list></div></div>");
  $templateCache.put("partials/myhuni/links.html", "<div class=row><my-huni-pills active-tab=links user-alert=userAlert></my-huni-pills></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12\"><loading-status status=status loading-message=\"Loading your links\" error-message=\"There was an error loading your links\" empty-message=\"You haven\'t made any links\"></loading-status><table class=\"table table-hover table-striped\" ng-show=\"status == \'ok\'\"><tbody><tr><thead><th>Source record</th><th>Relationship</th><th>Target record</th><th>Notes</th><th></th></thead></tr><tr ng-repeat=\"link in links\"><td><record-summary record=link.from></record-summary></td><td style=\"white-space: nowrap\" ng-if=\"link.linktype == link.pairtype\">{{link.linktype}}</td><td style=\"white-space: nowrap\" ng-if=\"link.linktype != link.pairtype\"><span class=\"glyphicon glyphicon-arrow-right\"></span> {{link.linktype}}<br><span class=\"glyphicon glyphicon-arrow-left\"></span> {{link.pairtype}}</td><td><record-summary record=link.to></record-summary></td><td><a ng-if=link.synopsis ng-href=#/link/{{link.id}}>{{link.synopsis | truncate:10}}</a></td><td align=right><button type=button class=\"btn btn-primary btn-sm my-collection\" title=\"Manage link\" ng-click=editLink(link)><span class=\"glyphicon icon-manage-link icon-sml\"></span></button> <button type=button class=\"btn btn-danger btn-sm my-collection\" title=\"Remove link\" ng-disabled=\"activeSnapIn.name == \'link\'\" ng-click=deleteLink(link)><span class=\"glyphicon icon-rem-link icon-sml\"></span></button> <a href=#/link/{{link.id}}><button type=button class=\"btn btn-primary btn-sm my-collection\" title=\"View link\"><span class=\"glyphicon icon-view-link icon-sml\"></span></button></a></td></tr></tbody></table></div></div>");
  $templateCache.put("partials/myhuni/profile.html", "<div class=row><my-huni-pills active-tab=profile user-alert=userAlert></my-huni-pills></div><hr><div class=row><loading-status status=status error-message=\"There was an error loading your profile\" loading-message=\"Loading your profile\"></loading-status><form class=form-horizontal role=form ng-show=\"status == \'ok\'\"><div class=panel-body><div class=\"form group\"><label class=\"col-sm-2 control-label\" for=input-name>Name</label><div class=col-sm-10><input id=input-name class=\"form-control my-huni\" type=text ng-model=user.name></div></div><div class=\"form group\"><label class=\"col-sm-2 control-label\" for=input-email>Email</label><div class=col-sm-10><input id=input-email class=\"form-control my-huni\" type=text ng-model=user.email></div></div><div class=\"form group\"><label class=\"col-sm-2 control-label\" for=input-institutions>Institutions</label><div class=col-sm-10><textarea id=input-institutions class=\"form-control my-huni\" ng-model=user.institutions placeholder=Institutions rows=3>\n          </textarea></div></div><div class=\"form group\"><label class=\"col-sm-2 control-label\" for=input-description>Description</label><div class=col-sm-10><textarea id=input-description class=\"form-control my-huni\" ng-model=user.description placeholder=Description rows=3>\n          </textarea></div></div><div class=\"form group\"><label class=\"col-sm-2 control-label\" for=input-interests>Interests</label><div class=col-sm-10><textarea id=input-interests class=\"form-control my-huni\" ng-model=user.interests placeholder=Interests rows=3>\n          </textarea></div></div><div class=\"form group\"><label class=\"col-sm-2 control-label\" for=input-collab>Collaboration Interests</label><div class=col-sm-10><textarea id=input-collab class=form-control ng-model=user.collaboration_interests placeholder=\"Collaboration Interests\" rows=3>\n          </textarea></div></div><div class=\"form group\"><label class=\"col-sm-2 control-label\" for=input-public>Make my profile public</label><div class=col-sm-10><input id=input-public type=checkbox ng-model=user.show_profile_info> Tick this box to make all the information above viewable on <a href=\"#/user/{{ user.id }}\">your public profile page</a>. If you leave this box unticked, only your name will be shown.</div></div><div class=\"form group\"><div class=col-sm-2></div><div class=col-sm-10><button class=\"btn btn-primary btn-sm update\" ng-click=update()>Update Profile</button></div></div></div></form></div>");
}]);
'use strict';

angular.module('huni').factory('CollectionRole', ['$log', function ($log) {

    var read_only_perms = 'view_records';
    var read_write_perms = 'edit_notes,add_records,' + read_only_perms;
    var owner_perms = 'publish,edit_title,delete,manage_users,' + read_write_perms;

    function makePermissions(permissionsList) {
        var permissions = {};
        _.each(permissionsList.split(','), function (permission) {
            permissions['can_' + permission] = true;
        });
        return permissions;
    }

    var roleInfo = {
        'owner': {
            order: 0,
            description: 'an owner',
            name: 'Owner',
            permissions: makePermissions(owner_perms)
        },

        'read-write': {
            order: 1,
            description: 'an editor',
            name: 'Editor',
            permissions: makePermissions(read_write_perms)
        },

        'read-only': {
            order: 2,
            description: 'a viewer',
            name: 'Viewer',
            permissions: makePermissions(read_only_perms)
        }
    };

    function permissions(roleId) {
        var role = roleInfo[roleId];
        if (!role) {
            $log.error('Unknown role ' + roleId);
            return {};
        }
        return role.permissions;
    }

    function options() {
        return _.chain(_.keys(roleInfo)).sortBy(function (roleId) {
            return roleInfo[roleId].order;
        }).map(function (roleId) {
            return { id: roleId, name: roleInfo[roleId].name };
        }).value();
    }

    function getInfo(roleId) {
        return angular.copy(roleInfo[roleId]);
    }

    return {
        getInfo: getInfo,
        options: options,
        permissions: permissions
    };
}]);
'use strict';

angular.module('huni').factory('DelayedCallService', ['$log', '$q', '$timeout', function ($log, $q, $timeout) {

    function wrap(name, func, delayMillis) {
        var pending = null;

        function cancelPending() {
            if (pending) {
                //$log.info(`Cancelling pending ${name} call`);
                $timeout.cancel(pending);
                pending = null;
            }
        }

        // The delayed version will cancel any pending calls, and schedule a
        // new call after delayMillis milliseconds.
        function delayed() {
            //$log.info(`Scheduling ${name} call in ${delayMillis}ms`);
            cancelPending();

            var args = arguments;
            function later() {
                pending = null;
                //$log.info(`Calling scheduled ${name} call`);
                return func.apply(func, args);
            }

            pending = $timeout(later, delayMillis);
            return pending;
        }

        // The immediate version will cancel any pending calls, and immediately
        // call the function. It returns an already-resolved promise.
        function immediate() {
            //$log.info(`Calling ${name} immediately`);
            cancelPending();

            var deferred = $q.defer();
            deferred.resolve(func.apply(undefined, arguments));
            return deferred.promise;
        }

        return {
            delayed: delayed,
            immediate: immediate
        };
    }

    // This module exports a single function.
    return wrap;
}]);
'use strict';

angular.module('huni').factory('DialogService', ['$modal', function ($modal) {

    // This does all the work of setting up a basic dialog.
    function showDialog(templateUrl, scopeParams) {
        var modalParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        modalParams.templateUrl = templateUrl;
        modalParams.controller = ['$scope', '$modalInstance', function ($scope, $modalInstance) {
            _.extend($scope, scopeParams);
        }];
        return $modal.open(modalParams).result;
    }

    function confirmationDialog(message) {
        return showDialog('partials/dialogs/confirmation.html', { message: message });
    }

    function linkDialog(link) {
        return showDialog('partials/dialogs/link-view.html', { link: link });
    }

    function licenceDialog() {
        return showDialog('partials/dialogs/licence.html');
    }

    return {
        confirmationDialog: confirmationDialog,
        licenceDialog: licenceDialog,
        linkDialog: linkDialog
    };
}]);
'use strict';

angular.module('huni').factory('EmbeddedMode', function () {

    var embeddedMode = false;

    // Whole service is just an accessor for the embeddedMode flag.
    //   const embeddedMode = EmbeddedMode.get();
    //   EmbeddedMode.set(embeddedMode);
    return {
        get: function get() {
            return embeddedMode;
        },
        set: function set(value) {
            embeddedMode = value;
        }
    };
});
'use strict';

angular.module('huni').factory('FacetService', ['$log', function ($log) {

    // fieldDefinitions is a hash of fieldName => displayName
    function create(displayName, facetName, queryParam, fieldDefinitions) {

        var fields = _.chain(fieldDefinitions).map(makeField).sortBy('displayName').value();

        function getSelectedFieldNames() {
            return _.chain(fields).where({ isSelected: true }).pluck('key').value();
        }

        function getTotalCount() {
            var allTotal = 0;
            var selectedTotal = 0;

            // If any of the facets are selected, the total of the selected
            // ones gives the count. If none are selected, the total of all.
            _.each(fields, function (field) {
                if (field.isSelected) {
                    selectedTotal += field.count;
                }
                allTotal += field.count;
            });

            return selectedTotal > 0 ? selectedTotal : allTotal;
        }

        function getUrlQueryParams(params) {
            var selection = getSelectedFieldNames();
            if (selection.length > 0) {
                params[queryParam] = selection;
            }
        }

        function makeField(displayName, key) {
            return {
                key: key,
                displayName: displayName,

                count: 0,
                isSelected: false
            };
        }

        function setCounts(histogram) {
            _.each(fields, function (field) {
                field.count = histogram[field.key] || 0;
            });
        }

        function setSelection(selection) {
            if (_.isUndefined(selection)) {
                return;
            }

            if (!_.isArray(selection)) {
                selection = [selection];
            }

            // Create a lookup hash from selection array.
            var isSelected = _.indexBy(selection, _.isIdentity);
            _.each(fields, function (field) {
                field.isSelected = _.has(isSelected, field.key);
            });
        }

        return {
            displayName: displayName,
            facetName: facetName,
            queryParam: queryParam,

            fields: fields,

            getSelectedFieldNames: getSelectedFieldNames,
            getTotalCount: getTotalCount,
            getUrlQueryParams: getUrlQueryParams,

            setCounts: setCounts,
            setSelection: setSelection
        };
    }

    return {
        create: create
    };
}]);
'use strict';

angular.module('huni').factory('FacetSetService', ['$log', 'FacetService', 'SearchFacets', function ($log, facetService, searchFacets) {

    function create(queryParams) {
        var facetList = [facetService.create('Category', 'entityType', 'c', _.object(searchFacets.entityTypes, searchFacets.entityTypes)), facetService.create('Data Provider', 'sourceAgencyCode', 's', searchFacets.providerNameTable)];

        var facetByfacetName = _.indexBy(facetList, 'facetName');

        function getSelectedFieldNames() {
            var selections = {};
            _.each(facetList, function (facet) {
                var selection = facet.getSelectedFieldNames();
                if (selection.length > 0) {
                    selections[facet.facetName] = selection;
                }
            });
            return selections;
        }

        function getTotalCount() {
            // Any one of these will do, might as well do the smallest one.
            //_.each(facetList, facet => facet.getTotalCount());
            return facetList[0].getTotalCount();
        }

        function getUrlQueryParams() {
            var params = {};
            _.each(facetList, function (facet) {
                facet.getUrlQueryParams(params);
            });
            return params;
        };

        function setCounts(facetName, histogram) {
            var facet = facetByfacetName[facetName];
            facet.setCounts(histogram);
        }

        _.each(facetList, function (facet) {
            facet.setSelection(queryParams[facet.queryParam]);
        });

        return {
            facets: facetList,
            facetNames: _.pluck(facetList, 'facetName'),

            getSelectedFieldNames: getSelectedFieldNames,
            getTotalCount: getTotalCount,
            getUrlQueryParams: getUrlQueryParams,
            setCounts: setCounts
        };
    }

    return {
        create: create
    };
}]);
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

angular.module('huni').factory('GraphQueryService', ['$http', '$log', '$q', 'HuniBackend', function ($http, $log, $q, backend) {

    // This limits the path length on reachableNode queries. Beyond this the
    // runtime explodes, and the actual results start to grow very slowly.
    var maxHops = 5;

    function shortestPathQuery(from_docid, to_docid) {
        // If we find a path, return that, otherwise, returns just the
        // endpoints as an unconnected pair. A path will have at least
        // three components [node, edge, node], so a two-element list will
        // always be distinct.
        var statement = '\n          MATCH (lhs:Entity { docid: {from_docid} }),\n                (rhs:Entity { docid: {to_docid}   })\n          WITH lhs, rhs\n          OPTIONAL MATCH p=shortestPath((lhs)-[:Link*]-(rhs))\n          RETURN coalesce(p, [ lhs, rhs ])\n      ';

        var parameters = { from_docid: from_docid, to_docid: to_docid };
        return doQuery(statement, parameters).then(function (result) {
            if (result.data.length == 0) {
                // We didn't even match the entities.
                return [];
            }
            return result.data[0].row[0];
        }).then(decorateLinks);
    }

    function decorateLinks(recordsAndLinks) {
        var links = _.filter(recordsAndLinks, function (x) {
            return _.has(x, 'linktype_id');
        });
        var user_ids = _.uniq(_.pluck(links, 'user_id'));

        if (user_ids.length == 0) {
            return recordsAndLinks;
        }

        // This gets called whether the user lookup works or not. As a fallback
        // we use 'User $id' as the username.
        function updateLinks(profileMap) {
            _.each(links, function (link) {
                if (!link.created_utc && link.created) {
                    link.created_utc = new Date(link.created);
                }
                if (!link.modified_utc && link.modified) {
                    link.modified_utc = new Date(link.modified);
                }
                if (!link.username && link.user_id) {
                    var user = profileMap[link.user_id];
                    link.username = user ? user.username : 'User ' + link.user_id;
                }
            });
        }

        return backend.get('/profile/find', { u: user_ids }).then(function (response) {
            var profileMap = _.indexBy(response.data, 'user_id');
            updateLinks(profileMap);
            return recordsAndLinks;
        }).catch(function (error) {
            updateLinks({});
            return recordsAndLinks;
        });
    }

    function makeStringMatchConditions(item, stringMatch) {
        var escaped = stringMatch.trim().toLowerCase().replace(/'/g, "\\'");
        if (escaped.length == 0) {
            return [];
        }
        return _.map(escaped.split(/\s+/), function (word) {
            return item + '.searchText CONTAINS \'' + word + '\'';
        });
    }

    function makeFacetMatchConditions(item, facet) {
        return _.map(_.keys(facet), function (key) {
            return item + '.' + key + ' IN {filter}.' + key;
        });
    }

    function reachableNodeFacet(from_docid, filter, field) {
        var stringMatch = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

        var conditions = _.flatten([makeFacetMatchConditions('rhs', filter), makeStringMatchConditions('rhs', stringMatch)]);
        var where = ['lhs <> rhs'].concat(_toConsumableArray(conditions)).join(' AND ');

        // maxHops and field are being interpolated in the statement, cypher does
        // not allow these to be parameters
        var statement = '\n          MATCH (lhs:Entity {docid: {from_docid}})\n          WITH lhs\n          MATCH (rhs:Entity)\n          WHERE ' + where + '\n          WITH lhs, rhs\n          MATCH (lhs)-[:Link*..' + maxHops + ']-(rhs)\n          WITH distinct(rhs) as nodes\n          WITH distinct(nodes.' + field + ') as name,\n               count(nodes.' + field + ') as count\n          RETURN name, count\n      ';

        var parameters = { from_docid: from_docid, filter: filter };
        //$log.log(statement, parameters);
        return doQuery(statement, parameters).then(function (result) {
            // Create a hash from an array of [ key, value ] pairs.
            var hist = _.object(_.map(result.data, function (item) {
                return item.row;
            }));
            return hist;
        });
    }

    function reachableNodeSearch(from_docid, filter, pageNumber, pageSize) {
        var stringMatch = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

        var conditions = _.flatten([makeFacetMatchConditions('rhs', filter), makeStringMatchConditions('rhs', stringMatch)]);
        var where = ['lhs <> rhs'].concat(_toConsumableArray(conditions)).join(' AND ');

        // Note we are interpolating maxHops in the statement - cypher does not
        // allow this to be a parameter.
        var statement = '\n          MATCH (lhs:Entity { docid: {from_docid} }),\n                (rhs:Entity),\n                path=((lhs)-[:Link *..' + maxHops + ']-(rhs))\n          WHERE ' + where + '\n          WITH distinct(rhs) as record, length(path) as pathLengths\n          ORDER BY pathLengths, record.docid\n          RETURN record, collect(pathLengths)[0] as pathLength\n          ORDER BY pathLength, record.docid\n          SKIP {skip}\n          LIMIT {limit}\n      ';

        var parameters = {
            from_docid: from_docid,
            skip: pageNumber * pageSize,
            limit: pageSize,
            filter: filter
        };

        //$log.log(statement, parameters);
        return doQuery(statement, parameters).then(function (result) {
            return _.map(result.data, function (item) {
                var _item$row = _slicedToArray(item.row, 2),
                    record = _item$row[0],
                    pathLength = _item$row[1];

                record.baconDistance = pathLength;
                record.bacon_docid = from_docid;
                return record;
            });
        });
    }

    function doQuery(statement) {
        var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var path = '/neo';
        var data = { statements: [{
                statement: statement,
                parameters: parameters
            }] };
        return $http.post(path, data).then(function (result) {
            var data = result.data;
            if (data.errors.length > 0) {
                _.each(data.errors, function (error) {
                    $log.error('Cypher error: ' + error.code);
                    _.each(error.message.split("\n"), function (message) {
                        $log.error(message);
                    });
                });
                return $q.reject('cypher query failed');
            }

            var results = data.results;
            if (results.length != 1) {
                $log.error('expecting 1 result, not ' + results.length);
                return $q.reject('expecting 1 result, not ' + results.length);
            }

            return result.data.results[0];
        });
    }

    return {
        reachableNodeFacet: reachableNodeFacet,
        reachableNodeSearch: reachableNodeSearch,
        shortestPathQuery: shortestPathQuery
    };
}]);
'use strict';

angular.module('huni').factory('HuniBackend', ['$rootScope', '$http', 'cfg', function ($rootScope, $http, cfg) {

    function uri(path) {
        if (path.substr(0, 1) != "/") {
            path = "/" + path;
        }
        return cfg.url + path;
    }

    function get(path, params) {
        return $http.get(uri(path), { params: params });
    };

    function put(path, data) {
        return $http.put(uri(path), data);
    };

    function post(path, data) {
        return $http.post(uri(path), data);
    };

    function deleteIsAReservedWord(path) {
        return $http.delete(uri(path));
    };

    return {
        delete: deleteIsAReservedWord,
        get: get,
        post: post,
        put: put,
        uri: uri
    };
}]);
'use strict';

angular.module('huni').factory('ReachableNodesSearch', ['$filter', '$log', '$q', 'DelayedCallService', 'FacetSetService', 'GraphQueryService', 'SolrSearchService', function ($filter, $log, $q, delayedCall, facetSetService, graphQuery, solrQuery) {

    function newSearch(queryParams, options) {
        var facetSet = facetSetService.create(queryParams);
        var docid = queryParams.docid;

        var recordsPerPage = 10;
        var searchDelayMillis = 1200;
        var search = {
            title: "Graph Search Results",
            hasSourceRecord: true,
            hasUserString: true,
            userString: queryParams.q || '',
            currentPage: queryParams.p || 1,
            // if queryParams.p > 1, then we need to set totalRecords to match,
            // otherwise the pagination controller freaks out and resets the
            // page to 1
            totalRecords: queryParams.p * recordsPerPage || 1,
            recordsPerPage: recordsPerPage,
            records: [], // this pages worth
            facet: facetSet,
            status: '' // user-facing search progress status
        };

        function updateFacetSelections(facetNameToSkip) {
            search.currentPage = 1;
            doSearch('delayed', function () {
                return {
                    records: recordSearch(),
                    facets: facetSearch(facetNameToSkip)
                };
            });
        }

        function updateUserString() {
            search.currentPage = 1;
            search.totalRecords = 0;
            doSearch('immediate', function () {
                return {
                    records: recordSearch(),
                    facets: facetSearch()
                };
            });
        };

        function makeFilter(facetNameToSkip) {
            var selections = facetSet.getSelectedFieldNames();
            return _.omit(selections, facetNameToSkip);
        };

        function recordSearch() {
            var filter = makeFilter();
            var page = search.currentPage - 1;
            var rows = recordsPerPage;
            var str = search.userString;

            return graphQuery.reachableNodeSearch(docid, filter, page, rows, str);
        }

        function facetSearch(facetNameToSkip) {
            var str = search.userString;
            var promises = {};
            var facetNames = _.without(facetSet.facetNames, facetNameToSkip);
            _.each(facetNames, function (facetName) {
                var filter = makeFilter(facetName);
                promises[facetName] = graphQuery.reachableNodeFacet(docid, filter, facetName, str);
            });
            return $q.all(promises);
        }

        function sourceSearch() {
            //console.log("Searching for", options);
            return solrQuery.getRecords([docid]).then(function (result) {
                if (result.length > 0) {
                    return result[0];
                }
                return undefined;
            });
        }

        function getUrlQueryParams() {
            var newQuery = facetSet.getUrlQueryParams();
            newQuery.docid = docid;
            if (search.currentPage > 1) {
                newQuery.p = search.currentPage;
            }
            var q = search.userString.trim();
            if (q.length > 0) {
                newQuery.q = q;
            }
            return newQuery;
        }

        function gotoPage(page) {
            search.currentPage = page;
            doSearch('immediate', function () {
                return {
                    records: recordSearch()
                };
            });
        }

        function finishSearchRaw(promisesFunc) {
            search.isBusy = true;
            return $q.all(promisesFunc()).then(function (result) {
                if (_.has(result, 'records')) {
                    search.records = result.records;
                }

                if (_.has(result, 'facets')) {
                    _.each(result.facets, function (histogram, facetName) {
                        facetSet.setCounts(facetName, histogram);
                    });
                }

                if (_.has(result, 'source')) {
                    search.source = result.source;
                }

                search.totalRecords = facetSet.getTotalCount();

                if (search.totalRecords > 0) {
                    var total = search.totalRecords;
                    var first = (search.currentPage - 1) * search.recordsPerPage + 1;
                    var last = first + search.recordsPerPage - 1;
                    if (last > total) {
                        last = total;
                    }
                    var number = $filter('number');
                    search.status = number(first) + ' - ' + number(last) + ' of ' + number(total);
                    search.loadingStatus = 'ok';
                } else {
                    search.status = 'No records found';
                    search.loadingStatus = 'empty';
                }
            }, function (failure) {
                search.status = 'Search failed. Try again later';
                search.loadingStatus = 'error';
            }).finally(function (result) {
                return search.isBusy = false;
            });
        }

        var finishSearch = delayedCall('ReachableNodesSearch', finishSearchRaw, searchDelayMillis);

        // when is either 'delayed' or 'immediate'
        function doSearch(when, promisesFunc) {
            search.records = [];
            search.status = 'Searching';
            search.loadingStatus = 'loading';

            finishSearch[when](promisesFunc);
        }

        _.extend(search, {
            getUrlQueryParams: getUrlQueryParams,
            gotoPage: gotoPage,
            updateFacetSelections: updateFacetSelections,
            updateUserString: updateUserString
        });

        if (options.source) {
            search.source = options.source;
        }

        doSearch('immediate', function () {
            return {
                records: recordSearch(),
                facets: facetSearch(),
                source: options.source || sourceSearch()
            };
        });

        return search;
    }

    return {
        newSearch: newSearch
    };
}]);
'use strict';

angular.module('huni').service('SettingsService', ['$cookieStore', function ($cookieStore) {

    var self = this;

    var cookieName = 'huni-settings';

    self.get = function (group, key) {
        var settings = $cookieStore.get(cookieName);
        if (settings) {
            var groupSettings = settings[group];
            if (groupSettings) {
                return groupSettings[key];
            }
        }
        return;
    };

    self.set = function (group, key, value) {
        var settings = $cookieStore.get(cookieName) || {};
        var groupSettings = settings[group];
        if (!groupSettings) {
            settings[group] = groupSettings = {};
        }
        groupSettings[key] = value;
        $cookieStore.put(cookieName, settings);
    };

    self.remove = function (group, key) {
        var settings = $cookieStore.get(cookieName);
        if (settings) {
            var groupSettings = settings[group];
            if (groupSettings && _.has(groupSettings, key)) {
                delete groupSettings[key];
                $cookieStore.put(cookieName, settings);
            }
        }
    };
}]);
'use strict';

angular.module('huni').factory('SolrSearchService', ['$http', '$log', '$q', 'cfg', function ($http, $log, $q, cfg) {

    function makeDisplayName(input) {
        if (input.displayName) {
            return input.displayName;
        }

        if (input.isDeleted) {
            return '[Deleted Record]';
        }

        // This record will have one of these:
        // * name only
        // * individualName and/or familyName
        // * none of the above
        // There's no overlap.
        return _.chain(['name', 'individualName', 'familyName']).map(function (field) {
            return input[field];
        }).compact().value().join(' ') || '[untitled]';
    }

    function formatDate(dateStr) {
        var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        var d = new Date(dateStr);
        var day = d.getUTCDate();
        var month = monthNames[d.getUTCMonth()];
        var year = d.getUTCFullYear();

        return [day, month, year].join(' ');
    }

    function parseRecordDates(record) {
        var dateKeys = ['birthDate', 'deathDate', 'creationDate', 'endDate', 'releaseDate', 'startDate'];
        dateKeys.forEach(function (key) {
            if (record[key]) record[key] = formatDate(record[key]);
        });

        return record;
    }

    function doQuery(query) {
        return $http({
            method: 'POST',
            url: cfg.solr + '/select',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data: query + '&wt=json'
        });
    }

    function doRecordsQuery(query) {
        return doQuery(query).then(function (resp) {
            _.each(resp.data.response.docs, function (record) {
                record.displayName = makeDisplayName(record);
                parseRecordDates(record);
            });

            return resp.data.response;
        });
    }

    // We can get lots of recordIds here. Break them into chunks and do one
    // call on each chunk.
    function getRecords(recordIds) {
        var chunkSize = 1000;
        var queryPromises = [];
        while (recordIds.length > 0) {
            var chunk = recordIds.splice(0, chunkSize);
            queryPromises.push(getRecordsChunk(chunk));
        }

        // Wait for all queries to complete, then flatten the list of lists
        // into a single list.
        return $q.all(queryPromises).then(function (recordLists) {
            return _.flatten(recordLists, true);
        });
    };

    // This looks up a single chunk of records.
    function getRecordsChunk(recordIds) {
        var query = 'rows=' + recordIds.length + '&q=' + _.chain(recordIds).map(function (id) {
            // The stars in the id need to be escaped, ftw!
            return "docid:" + id.replace(/\*/g, '\\*');
        }).join(' OR ').value();
        return doRecordsQuery(query).then(function (result) {
            return result.docs;
        });
    }

    /*
     * Given a list of partial records containing docid fields, lookup those
     * docids in solr, and merge the solr records with the partial records
     */
    function augmentRecords(dbRecords) {
        return getRecords(_.pluck(dbRecords, 'docid')).then(function (solrRecords) {
            var solrRecordMap = _.indexBy(solrRecords, 'docid');
            _.each(dbRecords, function (dbRecord) {
                var solrRecord = solrRecordMap[dbRecord.docid];
                _.extend(dbRecord, solrRecord);
            });
            return dbRecords;
        });
    };

    return {
        augmentRecords: augmentRecords,
        doQuery: doQuery,
        doRecordsQuery: doRecordsQuery,
        getRecords: getRecords
    };
}]);
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

angular.module('huni').factory('SolrTextSearch', ['$filter', '$log', '$q', 'DelayedCallService', 'FacetSetService', 'SolrSearchService', function ($filter, $log, $q, delayedCall, facetSetService, solr) {

    function newSearch(queryParams, options) {
        var facetSet = facetSetService.create(queryParams);

        var recordsPerPage = 10;
        var searchDelayMillis = 1200;

        var search = {
            hasUserString: true,
            title: "Quick Search Results",
            userString: queryParams.q || '*', // what the user has typed
            currentPage: queryParams.p || 1, // currentPage
            // if queryParams.p > 1, then we need to set totalRecords to match,
            // otherwise the pagination controller freaks out and resets the
            // page to 1
            totalRecords: // count of all records matching this search
            queryParams.p * recordsPerPage || 1,
            recordsPerPage: recordsPerPage, // page size
            records: [], // this pages worth of records
            facet: facetSet,
            status: '' // user-facing search progress status
        };

        function makeFacetQueryString(facetName) {
            return 'facet=true&facet.limit=-1&facet.field=' + facetName;
        }

        function makeFilterQueryString(facetNameToSkip) {
            var selections = _.omit(facetSet.getSelectedFieldNames(), facetNameToSkip);

            var fieldQueries = [];
            _.each(selections, function (selectedFieldNames, facetName) {
                var q = _.map(selectedFieldNames, function (key) {
                    return facetName + ':' + key;
                });
                fieldQueries.push('&fq=(' + q.join(' OR ') + ')');
            });
            return fieldQueries.join('');
        }

        // Not escaping star as we want that for the user
        var solrSpecialChars = /[+:&|!(){}\[\]\^"~?:\\]/g;

        function makeTextQueryString() {
            var terms = search.userString.split(/ /);
            var clauses = _.map(terms, function (s) {
                var esc = s.replace(solrSpecialChars, '\\$&');
                esc = encodeURIComponent(esc);
                // Just search on text, not text_rev.
                return '(text:' + esc + ')';
            });
            clauses.push('NOT (isDeleted:*)');
            if (clauses.length > 0) {
                return clauses.join(' AND ');
            }
            return '(text:*)';
        }

        function finishSearchRaw(promisesFunc) {
            search.isBusy = true;
            return $q.all(promisesFunc()).then(function (result) {
                if (_.has(result, 'records')) {
                    search.records = result.records.records;
                    search.totalRecords = result.records.total;
                }

                if (_.has(result, 'facets')) {
                    _.each(result.facets, function (histogram, facetName) {
                        facetSet.setCounts(facetName, histogram);
                    });
                }

                if (search.totalRecords > 0) {
                    var total = search.totalRecords;
                    var first = (search.currentPage - 1) * search.recordsPerPage + 1;
                    var last = first + search.recordsPerPage - 1;
                    if (last > total) {
                        last = total;
                    }
                    var number = $filter('number');
                    search.status = number(first) + ' - ' + number(last) + ' of ' + number(total);
                    search.loadingStatus = 'ok';
                } else {
                    search.status = 'No records found';
                    search.loadingStatus = 'empty';
                }
            }, function (failure) {
                search.status = 'Search failed. Try again later';
                search.loadingStatus = 'error';
            }).finally(function (result) {
                return search.isBusy = false;
            });
        }

        var finishSearch = delayedCall('SolrSearch', finishSearchRaw, searchDelayMillis);

        function doSearch(when, promisesFunc) {
            search.records = [];
            search.status = 'Searching';
            search.loadingStatus = 'loading';

            finishSearch[when](promisesFunc);
        }

        function facetSearch(facetNameToSkip) {
            var promises = {};
            var facetNames = _.without(facetSet.facetNames, facetNameToSkip);
            _.each(facetNames, function (facetName) {
                var query = 'q=' + makeTextQueryString(search.userString) + makeFilterQueryString(facetName) + '&' + makeFacetQueryString(facetName) + '&rows=0';

                promises[facetName] = solr.doQuery(query).then(function (response) {
                    var facets = response.data.facet_counts.facet_fields[facetName];

                    // facets is: [ key, count, key, count, ... ]
                    // split those into two arrays, so we can build a
                    // hash using _.object

                    var _$partition = _.partition(facets, function (value, index) {
                        return index % 2 == 0;
                    }),
                        _$partition2 = _slicedToArray(_$partition, 2),
                        keys = _$partition2[0],
                        counts = _$partition2[1];

                    var histogram = _.object(keys, counts);
                    return histogram;
                });
            });

            return $q.all(promises);
        }

        function recordSearch() {
            var sortString = '&sort=score desc,startDate asc,endDate asc,releaseDate asc';
            var query = 'q=' + makeTextQueryString(search.userString) + makeFilterQueryString() + '&rows=' + search.recordsPerPage + '&start=' + (search.currentPage - 1) * search.recordsPerPage + sortString;
            ;

            return solr.doRecordsQuery(query).then(function (result) {
                return {
                    total: result.numFound,
                    records: result.docs
                };
            });
        }

        function updateUserString() {
            if (search.userString === '') {
                search.userString = '*';
            }
            search.currentPage = 1;
            search.totalRecords = 0;
            doSearch('immediate', function () {
                return {
                    records: recordSearch(),
                    facets: facetSearch()
                };
            });
        };

        function updateFacetSelections(facetNameToSkip) {
            search.currentPage = 1;
            doSearch('delayed', function () {
                return {
                    records: recordSearch(),
                    facets: facetSearch(facetNameToSkip)
                };
            });
        };

        function gotoPage(page) {
            search.currentPage = page;
            doSearch('immediate', function () {
                return {
                    records: recordSearch()
                };
            });
        };

        function getUrlQueryParams() {
            var queryParams = facetSet.getUrlQueryParams(queryParams);
            if (search.userString != '*') {
                queryParams.q = search.userString;
            }
            if (search.currentPage > 1) {
                queryParams.p = search.currentPage;
            }
            return queryParams;
        };

        _.extend(search, {
            getUrlQueryParams: getUrlQueryParams,
            gotoPage: gotoPage,
            updateFacetSelections: updateFacetSelections,
            updateUserString: updateUserString
        });

        doSearch('immediate', function () {
            return {
                records: recordSearch(),
                facets: facetSearch()
            };
        });

        return search;
    };

    return {
        newSearch: newSearch
    };
}]);
'use strict';

angular.module('huni').service('UserMgtService', ['$rootScope', '$q', 'HuniBackend', function ($rootScope, $q, huniBackend) {

    var self = this;

    var userStatus = {};

    function setLoggedIn(data) {
        userStatus.id = data.user_id;
        userStatus.name = data.display_name;
        userStatus.newUser = data.new_user;
        userStatus.canEdit = data.can_edit;
        userStatus.loggedIn = true;
        userStatus.vlabUp = true;
        userStatus.owns = function (object) {
            return object && object.user_id === userStatus.id;
        };
    }

    function setLoggedOut(vlabUp) {
        userStatus.id = -1;
        userStatus.name = '';
        userStatus.newUser = false;
        userStatus.loggedIn = false;
        userStatus.canEdit = false;
        userStatus.vlabUp = vlabUp;
        userStatus.owns = function () {
            return false;
        };
    }

    var loginPromise = $q.defer();
    huniBackend.get('user').success(function (data) {
        if (data.user_id) {
            setLoggedIn(data);
        } else {
            setLoggedOut(true);
        }
    }).error(function () {
        setLoggedOut(false);
    }).finally(function () {
        loginPromise.resolve(userStatus);
    });

    $rootScope.$on('ProfileChangedEvent', function (e, profile) {
        userStatus.name = profile.name;
    });

    self.loginStatus = function () {
        return loginPromise.promise;
    };

    self.logout = function () {
        setLoggedOut(userStatus.vlabUp); // keep the vlabUp status
        return huniBackend.get('logout');
    };

    setLoggedOut(true);
}]);
'use strict';

angular.module('huni').value('MyHuniMenuItems', [{ page: 'collections', text: 'My Collections' }, { page: 'links', text: 'My Links' }, { page: 'profile', text: 'Profile' }]);
'use strict';

angular.module('huni').value('SearchFacets', {
    providerNameTable: {
        ACMI: "Australian Centre for the Moving Image",
        ADB: "Australian Dictionary of Biography",
        AFIRC: "AFI Research Collection",
        AMHD: "Australian Media History Database",
        ANMM: "Australian National Maritime Museum",
        AUS: "Australian Datasets",
        AusStage: "AusStage",
        AustLit: "AustLit",
        "AU-APFA": "Colonial Australian Popular Fiction",
        AWAP: "The Australian Women's Register",
        Bonza: "BONZA - National Cinema and Television Database",
        CAARP: "CAARP - Cinema and Audiences Research Project database",
        CAN: "Canadian Datasets",
        DAAO: "Design and ART Australia Online",
        EMEL: "Encyclopedia of Melbourne",
        EOAS: "Encyclopaedia of Australian Science",
        FCAC: "Find and Connect ACT",
        FCNA: "Find and Connect Australia",
        FCNS: "Find and Connect NSW",
        FCNT: "Find and Connect NT",
        FCQD: "Find and Connect Qld",
        FCSA: "Find and Connect SA",
        FCTS: "Find and Connect Tas",
        FCVC: "Find and Connect Vic",
        FCWA: "Find and Connect WA",
        GOLD: "Electronic Encyclopedia of Gold in Australia",
        HuNI: "HuNI Collections",
        MAP: "Media Archives Project",
        MVC: "Museums Victoria Collections",
        MURA: "Mura® the AIATSIS Collections Catalogue",
        OA: "Obituaries Australia",
        PDSC: "PARADISEC: Pacific and Regional Archive for Digital Sources in Endangered Cultures",
        SAUL: "Saulwick Polls and Social Research",
        Trove: "Trove",
        TUGG: "TUGG",
        UNSW: "University of New South Wales"
    },
    entityTypes: ['Concept', 'Event', 'Organisation', 'Person', 'Place', 'Work']
});